(function () {
  'use strict';

  var DEG2RAD = Math.PI / 180;
  var EARTH_RADIUS_KM = 6371;
  var MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  /**
   * Galaxy Ultra / some Android browsers report CSS width >767px; still need touch-map behavior.
   */
  function isTouchHandsetForMapGestures() {
    if (MOBILE_MQ.matches) return true;
    var w = typeof window.innerWidth === 'number' ? window.innerWidth : 0;
    if (w >= 1400) return false;
    var tp = 0;
    if (typeof navigator.maxTouchPoints === 'number') tp = navigator.maxTouchPoints;
    else if (typeof navigator.msMaxTouchPoints === 'number') tp = navigator.msMaxTouchPoints;
    var anyTouchApi = tp > 0 || 'ontouchstart' in window;
    if (!anyTouchApi) return false;
    try {
      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return true;
    } catch (err) {
      /* ignore */
    }
    try {
      if (window.matchMedia('(pointer: coarse)').matches && w <= 1280) return true;
    } catch (err2) {
      /* ignore */
    }
    return w > 0 && w <= 1200;
  }

  function haversineKm(lat1, lng1, lat2, lng2) {
    var dLat = (lat2 - lat1) * DEG2RAD;
    var dLng = (lng2 - lng1) * DEG2RAD;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * DEG2RAD) * Math.cos(lat2 * DEG2RAD) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_KM * c;
  }

  function milesBetween(a, b) {
    return haversineKm(a.lat, a.lng, b.lat, b.lng) * 0.621371;
  }

  function formatMiles(mi) {
    if (mi < 10) return mi.toFixed(1) + ' miles';
    return Math.round(mi) + ' miles';
  }

  var VE_DIST_UNIT_KEY = 'venue-explorer-distance-unit';

  function getDistanceUnit() {
    try {
      if (localStorage.getItem(VE_DIST_UNIT_KEY) === 'km') return 'km';
    } catch (e) {
      /* ignore */
    }
    return 'mi';
  }

  function setDistanceUnit(unit) {
    try {
      localStorage.setItem(VE_DIST_UNIT_KEY, unit === 'km' ? 'km' : 'mi');
    } catch (e) {
      /* ignore */
    }
  }

  function formatDistanceFromMiles(mi) {
    if (getDistanceUnit() === 'km') {
      var km = mi * 1.60934;
      if (km < 10) return km.toFixed(1) + ' km';
      return Math.round(km) + ' km';
    }
    return formatMiles(mi);
  }

  function esc(s) {
    if (s == null || s === '') return '';
    var d = document.createElement('div');
    d.textContent = String(s);
    return d.innerHTML;
  }

  /**
   * Like Element.closest but with a parent-walk fallback for older WebViews without closest.
   */
  function elementClosest(el, selector) {
    if (!el || !selector) return null;
    if (typeof el.closest === 'function') {
      return el.closest(selector);
    }
    var matches =
      el.matches ||
      el.webkitMatchesSelector ||
      el.mozMatchesSelector ||
      el.msMatchesSelector;
    if (!matches) return null;
    var node = el;
    while (node && node.nodeType === 1) {
      try {
        if (matches.call(node, selector)) return node;
      } catch (err) {
        return null;
      }
      node = node.parentElement;
    }
    return null;
  }

  function venueIdStr(v) {
    if (v == null || v.id == null) return '';
    return String(v.id);
  }

  function isValidVenueListImageUrl(url) {
    if (url == null) return false;
    var s = String(url).trim();
    if (!s || s === 'null' || s === 'undefined') return false;
    return (
      s.indexOf('http://') === 0 ||
      s.indexOf('https://') === 0 ||
      s.indexOf('//') === 0 ||
      s.indexOf('/') === 0
    );
  }

  /** Prefer absolute https so popup/list images load reliably. */
  function normalizeVenueImageUrl(url) {
    if (!isValidVenueListImageUrl(url)) return null;
    var s = String(url).trim();
    if (s.indexOf('//') === 0) return 'https:' + s;
    if (s.indexOf('/') === 0 && typeof window !== 'undefined' && window.location && window.location.origin) {
      return window.location.origin + s;
    }
    return s;
  }

  function getVenueListImage(venue) {
    if (!venue) return null;
    var url = venue.list_image || venue.venue_image || null;
    return normalizeVenueImageUrl(url);
  }

  function upscaleVenueImageUrl(url, width) {
    if (!url) return null;
    var w = width != null ? width : 680;
    var s = String(url);
    if (/([?&])width=\d+/i.test(s)) {
      return s.replace(/([?&])width=\d+/i, '$1width=' + w);
    }
    return s + (s.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  /** Popup cover: venue image (larger), else section fallback URL. */
  function getVenueCoverImageUrl(venue, rootEl) {
    var listImg = getVenueListImage(venue);
    if (listImg) return upscaleVenueImageUrl(listImg, 680);
    var root = rootEl || document.getElementById('venue-explorer');
    if (!root) return null;
    var fb = (root.getAttribute('data-popup-fallback-image') || '').trim();
    return normalizeVenueImageUrl(fb);
  }

  function registerVenueRefAliasKeys(keys, ref) {
    var idRaw = String(ref == null ? '' : ref).trim();
    if (!idRaw) return;
    keys.push('id:' + idRaw);
    keys.push('id:' + idRaw.toLowerCase());
    var nid = normalizeVenueRefId(idRaw);
    if (nid) {
      keys.push('id:' + nid);
      if (/^\d+$/.test(String(nid))) keys.push('id:gid://shopify/Metaobject/' + nid);
    }
  }

  function venueAliasKeys(venue) {
    var keys = [];
    if (!venue) return keys;
    registerVenueRefAliasKeys(keys, venueIdStr(venue));
    if (venue.venue_ref_id != null && String(venue.venue_ref_id).trim() !== '') {
      registerVenueRefAliasKeys(keys, venue.venue_ref_id);
    }
    var handle = venue.venue_handle != null ? String(venue.venue_handle).trim().toLowerCase() : '';
    if (handle) keys.push('h:' + handle);
    var name = venue.name != null ? String(venue.name).trim().toLowerCase() : '';
    if (name) keys.push('n:' + name);
    var city = venue.city != null ? String(venue.city).trim().toLowerCase() : '';
    if (!city && venue.address) city = extractCityFromAddress(venue.address);
    if (city && name) keys.push('cn:' + city + '|' + name);
    return keys;
  }

  function buildVenueLookup(rows) {
    var map = new Map();
    if (!Array.isArray(rows)) return map;
    rows.forEach(function (row) {
      venueAliasKeys(row).forEach(function (key) {
        if (!map.has(key)) map.set(key, row);
      });
    });
    return map;
  }

  function findVenueInLookup(venue, lookup) {
    if (!venue || !lookup) return null;
    var keys = venueAliasKeys(venue);
    for (var i = 0; i < keys.length; i++) {
      if (lookup.has(keys[i])) return lookup.get(keys[i]);
    }
    return null;
  }

  function venuesOverlap(a, b) {
    var bKeys = new Set(venueAliasKeys(b));
    return venueAliasKeys(a).some(function (key) {
      return bKeys.has(key);
    });
  }

  /** Metaobject list is authoritative; JSON only enriches matching rows (coords/address/image). */
  function mergeVenueCatalog(jsonRows, metaRows) {
    if (!metaRows || !metaRows.length) return jsonRows || [];
    if (!jsonRows || !jsonRows.length) return metaRows;

    var jsonLookup = buildVenueLookup(jsonRows);
    return metaRows.map(function (meta) {
      var merged = Object.assign({}, meta);
      var fromJson = findVenueInLookup(meta, jsonLookup);
      if (!fromJson) return merged;

      if (fromJson.lat != null && fromJson.lat !== '') merged.lat = fromJson.lat;
      if (fromJson.lng != null && fromJson.lng !== '') merged.lng = fromJson.lng;
      if (!merged.address && fromJson.address) merged.address = fromJson.address;
      if (!merged.city && fromJson.city) merged.city = fromJson.city;
      if (!merged.city_key && fromJson.city_key) merged.city_key = fromJson.city_key;
      if (!merged.phone && fromJson.phone) merged.phone = fromJson.phone;
      if (!merged.work_hours && fromJson.work_hours) merged.work_hours = fromJson.work_hours;
      if (!merged.workshops && fromJson.workshops) merged.workshops = fromJson.workshops;
      if (!merged.tags && fromJson.tags) merged.tags = fromJson.tags;
      if (!merged.state_code && fromJson.state_code) merged.state_code = fromJson.state_code;
      if (!merged.state_code) {
        merged.state_code = resolveVenueStateCode(merged);
      }

      var listImg = getVenueListImage(meta) || getVenueListImage(fromJson);
      if (listImg) {
        merged.list_image = listImg;
        merged.venue_image = listImg;
      }
      return merged;
    });
  }

  function normalizeVenues(rows) {
    if (!Array.isArray(rows)) return [];
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i] || {};
      var name = r.name != null ? String(r.name).trim() : '';
      var handle = r.venue_handle != null ? String(r.venue_handle).trim() : '';
      var fallbackId = handle || name || String(i + 1);
      var listImage = null;
      var rawImg = r.list_image || r.venue_image || r.image || null;
      if (isValidVenueListImageUrl(rawImg)) listImage = String(rawImg).trim();
      var idVal = r.id != null && String(r.id).trim() !== '' ? String(r.id).trim() : fallbackId;
      var refId = r.venue_ref_id != null && String(r.venue_ref_id).trim() !== '' ? String(r.venue_ref_id).trim() : '';
      if (!refId) {
        var idNum = normalizeVenueRefId(idVal);
        if (idNum && /^\d+$/.test(String(idNum))) refId = String(idNum);
      }
      out.push({
        id: idVal,
        venue_ref_id: refId,
        name: name,
        venue_handle: handle,
        city: r.city != null ? String(r.city).trim() : '',
        city_key: r.city_key != null ? String(r.city_key).trim() : '',
        address: r.address != null ? String(r.address).trim() : '',
        tags: r.tags != null ? r.tags : '',
        phone: r.phone != null ? String(r.phone).trim() : '',
        work_hours: r.work_hours != null ? String(r.work_hours).trim() : '',
        workshops: r.workshops != null ? r.workshops : '',
        list_image: listImage,
        venue_image: listImage,
        lat: r.lat != null && r.lat !== '' ? r.lat : null,
        lng: r.lng != null && r.lng !== '' ? r.lng : null,
        venue_kind: r.venue_kind != null ? r.venue_kind : '',
        state_code: resolveVenueStateCode({
          state: r.state,
          state_code: r.state_code,
          city_key: r.city_key,
          address: r.address != null ? String(r.address).trim() : ''
        })
      });
    }
    return out;
  }

  function parseInlineVenueData() {
    var dataEl = document.getElementById('venue-explorer-data');
    if (!dataEl || !dataEl.textContent) return [];
    try {
      var rows = JSON.parse(dataEl.textContent);
      return normalizeVenues(Array.isArray(rows) ? rows : []);
    } catch (e) {
      console.warn('[venue-explorer] Inline venue JSON could not be parsed.');
      return [];
    }
  }

  function googleDirectionsUrl(lat, lng) {
    return (
      'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(String(lat) + ',' + String(lng))
    );
  }

  function venueTagsShort(venue, maxLen) {
    maxLen = maxLen || 110;
    var t = venue && venue.tags;
    if (t == null) return '';
    var parts = [];
    if (Array.isArray(t)) {
      for (var i = 0; i < t.length && i < 4; i++) {
        if (t[i] != null && String(t[i]).trim() !== '') parts.push(String(t[i]).trim());
      }
    } else if (typeof t === 'string') {
      var s = t.trim();
      if (!s) return '';
      if (s.charAt(0) === '[') {
        try {
          var parsed = JSON.parse(s);
          if (Array.isArray(parsed)) {
            for (var j = 0; j < parsed.length && j < 4; j++) {
              if (parsed[j] != null && String(parsed[j]).trim() !== '') parts.push(String(parsed[j]).trim());
            }
          }
        } catch (e) {
          return s.length > maxLen ? s.slice(0, maxLen - 1) + '\u2026' : s;
        }
      } else {
        return s.length > maxLen ? s.slice(0, maxLen - 1) + '\u2026' : s;
      }
    }
    var out = parts.join(' \u00b7 ');
    if (out.length > maxLen) return out.slice(0, maxLen - 1) + '\u2026';
    return out;
  }

  var VE_LIST_THUMB_PX = 44;

  var VE_WORKSHOP_TYPE_ORDER = ['mosaic', 'ceramic', 'resin'];
  var VE_WORKSHOP_TYPES = {
    mosaic: {
      label: 'Mosaic',
      handle: 'mosaic-lamp-workshop',
      aliases: ['mosaic-workshop', 'mosaic-classes', 'mosaic-classess']
    },
    ceramic: {
      label: 'Ceramic',
      handle: 'ceramic-painting-workshop',
      aliases: ['ceramic-painting-classes', 'ceramic-painting-classess']
    },
    resin: {
      label: 'Resin',
      handle: 'resin-art-workshop',
      aliases: ['resin-art', 'resin-workshop']
    }
  };

  var venueWorkshopEvents = [];
  var venueWorkshopTypesIndex = Object.create(null);
  var venueBookableWorkshopTypesIndex = Object.create(null);
  var veWorkshopProductHandles = Object.create(null);
  var veWorkshopProductIds = Object.create(null);

  function parseWorkshopProductHandles() {
    var el = document.getElementById('venue-explorer-workshop-handles');
    if (!el || !el.textContent) return;
    try {
      var data = JSON.parse(el.textContent);
      if (!data || typeof data !== 'object') return;
      VE_WORKSHOP_TYPE_ORDER.forEach(function (type) {
        var entry = data[type];
        if (entry == null) return;
        if (typeof entry === 'string') {
          var handleOnly = String(entry).trim();
          if (handleOnly) veWorkshopProductHandles[type] = handleOnly;
          return;
        }
        if (typeof entry === 'object') {
          var handle = entry.handle != null ? String(entry.handle).trim() : '';
          var id = entry.id != null ? String(entry.id).trim() : '';
          if (handle) veWorkshopProductHandles[type] = handle;
          if (id) veWorkshopProductIds[type] = id;
        }
      });
    } catch (e) {
      /* ignore */
    }
  }

  function veEventDedupeKey(ev) {
    if (!ev) return '';
    if (ev.id != null && String(ev.id).trim() !== '') return 'id:' + String(ev.id).trim();
    var ref = ev.venue_ref_id != null ? String(ev.venue_ref_id).trim() : '';
    var dk = ev.date_key != null ? String(ev.date_key).trim() : '';
    var tl = ev.time_label != null ? String(ev.time_label).trim() : '';
    var ph = ev.product_handle != null ? String(ev.product_handle).trim() : '';
    return [ref, dk, tl, ph].join('|');
  }

  function flattenWorkshopEventsFromApiPayload(data, productHandle) {
    var out = [];
    if (!data || !Array.isArray(data.groups)) return out;
    data.groups.forEach(function (group) {
      var venues = (group && group.venues) || [];
      venues.forEach(function (venue) {
        var events = (venue && venue.events) || [];
        events.forEach(function (ev) {
          if (!ev || typeof ev !== 'object') return;
          var row = Object.assign({}, ev);
          if (row.venue_ref_id == null || String(row.venue_ref_id).trim() === '') {
            row.venue_ref_id = venue.venue_ref_id != null ? venue.venue_ref_id : venue.id;
          }
          if (!row.venue_name) {
            row.venue_name = venue.venue_name || venue.name || venue.city_name || '';
          }
          if (!row.venue_handle) {
            row.venue_handle = venue.venue_handle || venue.handle || '';
          }
          if (!row.city) {
            row.city = venue.city_name || venue.city || group.city_name || '';
          }
          if (!row.state_code) {
            row.state_code = venue.state_code || group.state_code || '';
          }
          if (!row.product_handle && productHandle) {
            row.product_handle = productHandle;
          }
          out.push(row);
        });
      });
    });
    return out;
  }

  function mergeWorkshopEventLists(baseRows, extraRows) {
    var out = [];
    var seen = Object.create(null);
    function pushAll(rows) {
      if (!Array.isArray(rows)) return;
      rows.forEach(function (ev) {
        var key = veEventDedupeKey(ev);
        if (!key || seen[key]) return;
        seen[key] = true;
        out.push(ev);
      });
    }
    pushAll(baseRows);
    pushAll(extraRows);
    return out;
  }

  function extractCityFromAddress(addr) {
    var s = String(addr == null ? '' : addr).trim();
    if (!s) return '';
    var m = s.match(/,\s*([^,]+),\s*[A-Z]{2}\b/i);
    return m ? normVenueToken(m[1]) : '';
  }

  function extractStateFromAddress(addr) {
    var s = String(addr == null ? '' : addr).trim();
    if (!s) return '';
    var m = s.match(/,\s*[A-Za-z .'-]+,\s*([A-Z]{2})\s+\d{5}\b/);
    return m ? normVenueToken(m[1]) : '';
  }

  var US_STATE_NAMES = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    DC: 'District of Columbia'
  };

  function venueSearchCityLabel(venue) {
    if (!venue) return '';
    var city = venue.city != null ? String(venue.city).trim() : '';
    if (!city && venue.name) city = String(venue.name).trim();
    if (!city && venue.address) {
      var fromAddr = extractCityFromAddress(venue.address);
      if (fromAddr) city = fromAddr.replace(/\b\w/g, function (ch) {
        return ch.toUpperCase();
      });
    }
    return city;
  }

  function venueSearchRegionLabel(venue) {
    var code = resolveVenueStateCode(venue);
    if (code && US_STATE_NAMES[code]) return US_STATE_NAMES[code];
    if (code) return code;
    return '';
  }

  /** Primary line for inventory autocomplete, e.g. "Lincoln, Nebraska". */
  function formatVenueSearchLabel(venue) {
    var city = venueSearchCityLabel(venue);
    var region = venueSearchRegionLabel(venue);
    if (city && region) return city + ', ' + region;
    if (city) return city;
    if (venue && venue.name) return String(venue.name).trim();
    return '';
  }

  function venueSearchHaystack(venue) {
    if (!venue) return '';
    var parts = [
      venue.name,
      venue.city,
      venue.address,
      venue.state_code,
      venue.venue_handle,
      formatVenueSearchLabel(venue),
      venueSearchRegionLabel(venue)
    ];
    return parts
      .filter(function (p) {
        return p != null && String(p).trim() !== '';
      })
      .join(' ')
      .toLowerCase();
  }

  function filterVenuesBySearchQuery(rows, query) {
    var q = String(query == null ? '' : query)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
    if (!q || !Array.isArray(rows)) return [];
    var tokens = q.split(' ').filter(Boolean);
    var scored = [];
    rows.forEach(function (venue) {
      var label = formatVenueSearchLabel(venue).toLowerCase();
      var city = venueSearchCityLabel(venue).toLowerCase();
      var name = venue.name != null ? String(venue.name).trim().toLowerCase() : '';
      var hay = venueSearchHaystack(venue);
      if (!hay) return;
      var allMatch = tokens.every(function (t) {
        return hay.indexOf(t) !== -1;
      });
      if (!allMatch) return;
      var score = 0;
      if (city === q || name === q || label === q) score = 300;
      else if (city.indexOf(q) === 0 || name.indexOf(q) === 0 || label.indexOf(q) === 0) score = 200;
      else if (city.indexOf(q) !== -1 || name.indexOf(q) !== -1) score = 100;
      else score = 50;
      scored.push({ venue: venue, score: score, label: formatVenueSearchLabel(venue) });
    });
    scored.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
    });
    return scored;
  }

  function workshopEventVenueToken(ev) {
    if (!ev) return '';
    if (ev.venue_ref_id != null && String(ev.venue_ref_id).trim() !== '') {
      var num = normalizeVenueRefId(ev.venue_ref_id);
      if (num && /^\d+$/.test(String(num))) return String(num);
      var rawRef = String(ev.venue_ref_id).trim();
      if (rawRef) return rawRef;
    }
    if (ev.venue_handle != null && String(ev.venue_handle).trim() !== '') {
      return String(ev.venue_handle).trim();
    }
    return '';
  }

  function workshopEventAliasKeys(ev) {
    var keys = [];
    var seen = Object.create(null);
    function add(k) {
      k = String(k || '').trim();
      if (!k || seen[k]) return;
      seen[k] = true;
      keys.push(k);
    }
    if (!ev) return keys;
    if (ev.venue_ref_id != null && String(ev.venue_ref_id).trim() !== '') {
      var raw = String(ev.venue_ref_id).trim();
      add('id:' + raw);
      add('id:' + raw.toLowerCase());
      var nid = normalizeVenueRefId(raw);
      if (nid) {
        add('id:' + nid);
        if (/^\d+$/.test(String(nid))) add('id:gid://shopify/Metaobject/' + nid);
      }
    }
    var h = normVenueToken(ev.venue_handle);
    if (h) add('h:' + h);
    var n = normVenueToken(ev.venue_name);
    if (n) add('n:' + n);
    var c = normVenueToken(ev.city);
    if (c && n) add('cn:' + c + '|' + n);
    return keys;
  }

  function indexVenueWorkshopEvents(events) {
    venueWorkshopTypesIndex = Object.create(null);
    venueBookableWorkshopTypesIndex = Object.create(null);
    if (!Array.isArray(events)) return;
    events.forEach(function (ev) {
      var type = workshopTypeFromProductHandle(ev.product_handle);
      if (!type) return;
      var bookable = isBookableWorkshopEvent(ev);
      workshopEventAliasKeys(ev).forEach(function (key) {
        if (!venueWorkshopTypesIndex[key]) venueWorkshopTypesIndex[key] = Object.create(null);
        venueWorkshopTypesIndex[key][type] = true;
        if (bookable) {
          if (!venueBookableWorkshopTypesIndex[key]) venueBookableWorkshopTypesIndex[key] = Object.create(null);
          venueBookableWorkshopTypesIndex[key][type] = true;
        }
      });
    });
  }

  function collectWorkshopTypesFromIndex(venue, index) {
    var found = Object.create(null);
    if (!venue || !index) return found;
    venueAliasKeys(venue).forEach(function (key) {
      var bucket = index[key];
      if (!bucket) return;
      VE_WORKSHOP_TYPE_ORDER.forEach(function (type) {
        if (bucket[type]) found[type] = true;
      });
    });
    return found;
  }

  function todayDateKey() {
    var d = new Date();
    return (
      d.getFullYear() +
      '-' +
      String(d.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(d.getDate()).padStart(2, '0')
    );
  }

  function normVenueToken(val) {
    return String(val == null ? '' : val)
      .trim()
      .toLowerCase()
      .replace(/\./g, '')
      .replace(/\s+/g, ' ');
  }

  function compactVenueLabel(val) {
    return normVenueToken(val).replace(/[^a-z0-9]/g, '');
  }

  function normalizeVenueRefId(ref) {
    var s = String(ref == null ? '' : ref).trim();
    if (!s) return '';
    if (/^\d+$/.test(s)) return s;
    var m = s.match(/(\d+)\s*$/);
    return m ? m[1] : s.toLowerCase();
  }

  function parseWorkshopTypesField(raw) {
    if (raw == null || raw === '') return [];
    var out = [];
    var parts = [];
    if (Array.isArray(raw)) {
      parts = raw;
    } else if (typeof raw === 'string') {
      if (raw.charAt(0) === '[') {
        try {
          parts = JSON.parse(raw);
        } catch (e) {
          parts = raw.split(/[,;|/]+/);
        }
      } else {
        parts = raw.split(/[,;|/]+/);
      }
    }
    parts.forEach(function (part) {
      var t = normVenueToken(part);
      if (t.indexOf('mosaic') >= 0) out.push('mosaic');
      else if (t.indexOf('ceramic') >= 0) out.push('ceramic');
      else if (t.indexOf('resin') >= 0) out.push('resin');
      else if (VE_WORKSHOP_TYPES[t]) out.push(t);
    });
    return out;
  }

  function workshopTypeFromProductHandle(handle) {
    handle = normVenueToken(handle);
    if (!handle) return '';
    for (var ti = 0; ti < VE_WORKSHOP_TYPE_ORDER.length; ti++) {
      var t = VE_WORKSHOP_TYPE_ORDER[ti];
      var pageHandle = veWorkshopProductHandles[t];
      if (pageHandle && normVenueToken(pageHandle) === handle) return t;
    }
    for (var i = 0; i < VE_WORKSHOP_TYPE_ORDER.length; i++) {
      var type = VE_WORKSHOP_TYPE_ORDER[i];
      var cfg = VE_WORKSHOP_TYPES[type];
      if (!cfg) continue;
      if (handle === normVenueToken(cfg.handle)) return type;
      if (cfg.aliases) {
        for (var j = 0; j < cfg.aliases.length; j++) {
          if (handle === normVenueToken(cfg.aliases[j])) return type;
        }
      }
      if (handle.indexOf(type) >= 0) return type;
    }
    return '';
  }

  function isBookableWorkshopEvent(ev) {
    if (!ev) return false;
    var status = normVenueToken(ev.status).replace(/\s+/g, '_').replace(/-/g, '_');
    if (status !== 'active' && status !== 'sold_out') return false;
    var dk = String(ev.date_key || '').trim();
    if (!dk) return true;
    return dk >= todayDateKey();
  }

  function aliasKeysOverlap(aKeys, bKeys) {
    var set = new Set(aKeys);
    for (var i = 0; i < bKeys.length; i++) {
      if (set.has(bKeys[i])) return true;
    }
    return false;
  }

  function venueMatchesEvent(venue, ev) {
    if (!venue || !ev) return false;
    if (aliasKeysOverlap(venueAliasKeys(venue), workshopEventAliasKeys(ev))) return true;

    var vname = normVenueToken(venue.name);
    var ename = normVenueToken(ev.venue_name);
    var vcity = normVenueToken(venue.city) || extractCityFromAddress(venue.address);
    var ecity = normVenueToken(ev.city);

    if (vname && ename) {
      if (vname === ename) return true;
      if (vname.indexOf(ename) >= 0 || ename.indexOf(vname) >= 0) {
        if (!vcity || !ecity || vcity === ecity) return true;
      }
      if (vcity && ename.indexOf(vcity) >= 0) return true;
    }

    if (vname && ecity && vname === ecity) return true;
    if (vcity && ecity && vcity === ecity) {
      if (!vname || !ename || vname === ecity || ename.indexOf(vcity) >= 0 || vname === ename) return true;
    }

    var vcompact = compactVenueLabel(venue.name || venue.city || extractCityFromAddress(venue.address));
    var ecityCompact = compactVenueLabel(ev.city);
    var enameCompact = compactVenueLabel(ev.venue_name);
    if (vcompact && ecityCompact && vcompact === ecityCompact) return true;
    if (vcompact && enameCompact && (vcompact === enameCompact || enameCompact.indexOf(vcompact) >= 0)) return true;

    var vhandle = normVenueToken(venue.venue_handle);
    var ehandle = normVenueToken(ev.venue_handle);
    if (vhandle && ehandle && vhandle === ehandle) return true;

    return false;
  }

  function findVenueWorkshopEvent(venue, type, bookableOnly) {
    if (!venue || !type || !venueWorkshopEvents.length) return null;
    for (var i = 0; i < venueWorkshopEvents.length; i++) {
      var ev = venueWorkshopEvents[i];
      if (workshopTypeFromProductHandle(ev.product_handle) !== type) continue;
      if (!venueMatchesEvent(venue, ev)) continue;
      if (bookableOnly && !isBookableWorkshopEvent(ev)) continue;
      return ev;
    }
    return null;
  }

  function findBookableEventForVenueType(venue, type) {
    var direct = findVenueWorkshopEvent(venue, type, true);
    if (direct) return direct;

    var vcity = normVenueToken(venue.city) || extractCityFromAddress(venue.address);
    var vstate = extractStateFromAddress(venue.address);
    var vname = normVenueToken(venue.name);

    for (var i = 0; i < venueWorkshopEvents.length; i++) {
      var ev = venueWorkshopEvents[i];
      if (workshopTypeFromProductHandle(ev.product_handle) !== type) continue;
      if (!isBookableWorkshopEvent(ev)) continue;

      var ecity = normVenueToken(ev.city);
      var estate = normVenueToken(ev.state_code || ev.state);
      if (vcity && ecity && (vcity === ecity || compactVenueLabel(vcity) === compactVenueLabel(ecity))) {
        if (!vstate || !estate || vstate === estate || estate.length !== 2) return ev;
      }

      var ename = normVenueToken(ev.venue_name);
      if (vname && ecity && (vname === ecity || compactVenueLabel(vname) === compactVenueLabel(ecity))) return ev;
      if (vcity && ename && (ename.indexOf(vcity) >= 0 || compactVenueLabel(ename).indexOf(compactVenueLabel(vcity)) >= 0)) {
        return ev;
      }

      var vhandle = normVenueToken(venue.venue_handle);
      var ehandle = normVenueToken(ev.venue_handle);
      if (vhandle && ehandle && vhandle === ehandle) return ev;
    }

    return null;
  }

  function venueHasWorkshopEvent(venue, type) {
    return !!findBookableEventForVenueType(venue, type);
  }

  /** True if venue has at least one active/sold_out event on or after today. */
  function venueHasUpcomingWorkshop(venue) {
    if (!venue || !venueWorkshopEvents.length) return false;
    var i;
    for (i = 0; i < venueWorkshopEvents.length; i++) {
      var ev = venueWorkshopEvents[i];
      if (!isBookableWorkshopEvent(ev)) continue;
      if (venueMatchesEvent(venue, ev)) return true;
    }
    var types = getVenueWorkshopTypes();
    for (i = 0; i < types.length; i++) {
      if (findBookableEventForVenueType(venue, types[i])) return true;
    }
    return false;
  }

  function venueUrlTokenForWorkshop(venue, type) {
    var ev = findBookableEventForVenueType(venue, type);
    if (ev) {
      var fromEvent = workshopEventVenueToken(ev);
      if (fromEvent) return fromEvent;
    }
    return venueUrlToken(venue);
  }

  function resolveWorkshopChipLink(venue, type) {
    var ev = findBookableEventForVenueType(venue, type);
    var hasDeepLink = !!ev;
    var token = '';
    if (hasDeepLink) {
      token = workshopEventVenueToken(ev) || venueUrlToken(venue);
      var num = normalizeVenueRefId(token);
      if (num && /^\d+$/.test(String(num))) token = String(num);
    }
    var cfg = VE_WORKSHOP_TYPES[type];
    var handle =
      (veWorkshopProductHandles[type] && String(veWorkshopProductHandles[type]).trim()) ||
      (cfg && cfg.handle ? cfg.handle : 'mosaic-lamp-workshop');
    var url = '/products/' + handle;
    if (hasDeepLink && token) {
      url += '?venue=' + encodeURIComponent(token) + '&wbw_step=datetime';
    }
    return { url: url, live: hasDeepLink && !!token };
  }

  function getVenueWorkshopTypes() {
    return VE_WORKSHOP_TYPE_ORDER.slice();
  }

  function venueUrlToken(venue) {
    if (venue.venue_ref_id != null && String(venue.venue_ref_id).trim() !== '') {
      var refNum = normalizeVenueRefId(venue.venue_ref_id);
      if (refNum && /^\d+$/.test(String(refNum))) return String(refNum);
    }
    var id = venueIdStr(venue);
    if (id) {
      var num = normalizeVenueRefId(id);
      if (num && /^\d+$/.test(String(num))) return String(num);
    }
    var handle = venue.venue_handle != null ? String(venue.venue_handle).trim() : '';
    return handle || '';
  }

  function workshopProductHandleForType(type) {
    var fromSettings =
      veWorkshopProductHandles[type] != null ? String(veWorkshopProductHandles[type]).trim() : '';
    if (fromSettings) return fromSettings;
    var cfg = VE_WORKSHOP_TYPES[type];
    return cfg && cfg.handle ? cfg.handle : 'mosaic-lamp-workshop';
  }

  /**
   * Book-a-workshop deep link: /products/{handle}?venue={metaobjectId}
   * Prefer a type with a matching event; otherwise mosaic product + venue id.
   */
  function resolveVenueEventPageUrl(venue) {
    var token = venueUrlToken(venue);
    var types = getVenueWorkshopTypes();
    var handle = workshopProductHandleForType('mosaic');
    var i;
    for (i = 0; i < types.length; i++) {
      if (findBookableEventForVenueType(venue, types[i])) {
        handle = workshopProductHandleForType(types[i]);
        break;
      }
    }
    if (!token) {
      for (i = 0; i < types.length; i++) {
        if (findVenueWorkshopEvent(venue, types[i], false)) {
          handle = workshopProductHandleForType(types[i]);
          var evToken = workshopEventVenueToken(findVenueWorkshopEvent(venue, types[i], false));
          if (evToken) {
            var num = normalizeVenueRefId(evToken);
            token = num && /^\d+$/.test(String(num)) ? String(num) : evToken;
          }
          break;
        }
      }
    }
    var url = '/products/' + handle;
    if (token) url += '?venue=' + encodeURIComponent(token);
    return url;
  }

  function veDirectionsIconSvg() {
    return (
      '<svg class="ve-map-popup__directions-icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M21.44 2.56a1.5 1.5 0 0 0-1.59-.28L3.7 9.1a1.5 1.5 0 0 0 .08 2.82l6.6 1.7 1.7 6.6a1.5 1.5 0 0 0 2.82.08l6.82-16.15a1.5 1.5 0 0 0-.28-1.59zM14.6 14.6l-.9-3.5 2.72-2.72-3.9 1.64-3.5-.9 8.58-3.52-2.99 9z"/>' +
      '</svg>'
    );
  }

  function veCalendarIconSvg() {
    return (
      '<svg class="ve-map-popup__cta-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM7 12h5v5H7v-5z"/>' +
      '</svg>'
    );
  }

  function buildVenueDirectionsBtnHtml(dirUrl) {
    return (
      '<a class="ve-map-popup__directions-btn" href="' +
      esc(dirUrl) +
      '" target="_blank" rel="noopener noreferrer">' +
      veDirectionsIconSvg() +
      '<span class="ve-map-popup__directions-label">Get directions</span></a>'
    );
  }

  /** List drawer: venue photo, or neutral placeholder when image is missing. */
  function buildVenueCardThumbHtml(venue, kind, markerColors) {
    var listImg = getVenueListImage(venue);
    if (listImg) {
      return (
        '<img src="' +
        esc(listImg) +
        '" alt="" width="' +
        VE_LIST_THUMB_PX +
        '" height="' +
        VE_LIST_THUMB_PX +
        '" loading="lazy" class="ve-card__thumb ve-card__thumb--photo" decoding="async" onerror="this.onerror=null;this.className=\'ve-card__thumb ve-card__thumb--placeholder\';this.removeAttribute(\'src\');">'
      );
    }
    return '<span class="ve-card__thumb ve-card__thumb--placeholder" aria-hidden="true"></span>';
  }

  function buildVenueMapPopupHtml(venue, coords, workshopBase) {
    var dirUrl = googleDirectionsUrl(coords.lat, coords.lng);
    var kind = resolveMarkerKind(venue);
    var cityLabel = venueSearchCityLabel(venue) || (venue.name != null ? String(venue.name).trim() : '');
    var coverUrl = getVenueCoverImageUrl(venue);
    var eventUrl = resolveVenueEventPageUrl(venue);
    var addr = venue.address != null ? String(venue.address).trim() : '';
    var parts = [];

    parts.push('<div class="ve-map-popup ve-map-popup--' + esc(kind) + ' ve-map-popup--event ve-map-popup--animate">');
    parts.push(
      '<button type="button" class="ve-map-popup__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
        '<path fill="currentColor" d="M18.3 5.71L12 12.01 5.7 5.7 4.29 7.11 10.59 13.4 4.29 19.7 5.7 21.11 12 14.82l6.3 6.29 1.41-1.41-6.29-6.3 6.29-6.29z"/>' +
        '</svg></button>'
    );

    parts.push('<div class="ve-map-popup__cover' + (coverUrl ? '' : ' ve-map-popup__cover--fallback') + '">');
    if (coverUrl) {
      parts.push(
        '<img class="ve-map-popup__cover-img" src="' +
          esc(coverUrl) +
          '" alt="" width="340" height="160" loading="lazy" decoding="async">'
      );
    }
    if (cityLabel) {
      parts.push(
        '<div class="ve-map-popup__cover-title"><span>Workshops in ' + esc(cityLabel) + '</span></div>'
      );
    }
    parts.push('</div>');

    parts.push('<div class="ve-map-popup__body">');
    if (cityLabel) {
      parts.push('<h3 class="ve-map-popup__title">' + esc(cityLabel) + '</h3>');
    } else if (venue.name) {
      parts.push('<h3 class="ve-map-popup__title">' + esc(String(venue.name).trim()) + '</h3>');
    }

    parts.push('<hr class="ve-map-popup__rule" />');

    parts.push('<div class="ve-map-popup__location">');
    parts.push('<span class="ve-map-popup__label">Location</span>');
    parts.push('<div class="ve-map-popup__location-row">');
    if (addr) {
      parts.push('<p class="ve-map-popup__address">' + esc(addr) + '</p>');
    }
    parts.push(buildVenueDirectionsBtnHtml(dirUrl));
    parts.push('</div></div>');

    parts.push(
      '<a class="ve-map-popup__cta button button-solid" href="' +
        esc(eventUrl) +
        '">' +
        veCalendarIconSvg() +
        '<span class="button-text">Go to Event Page</span></a>'
    );
    parts.push('</div>');

    parts.push('</div>');
    return parts.join('');
  }

  /**
   * Optional AU/NZ-only latitude sign repair (section setting data-fix-au-nz-lat).
   * US / Americas: usually no match; disable checkbox if you do not need legacy AU/NZ CMS fixes.
   */
  function maybeFixMisenteredSouthernLat(lat, lng) {
    if (typeof lat !== 'number' || typeof lng !== 'number' || Number.isNaN(lat) || Number.isNaN(lng)) {
      return { lat: lat, lng: lng };
    }
    if (lat <= 0) return { lat: lat, lng: lng };
    if (lng >= 147 && lng <= 154 && lat >= 10 && lat <= 40) return { lat: -lat, lng: lng };
    if (lng >= 166 && lng <= 179 && lat > 0 && lat <= 48) return { lat: -lat, lng: lng };
    return { lat: lat, lng: lng };
  }

  /** Contiguous US default view (lng, lat). */
  var VE_DEFAULT_CENTER = [-98.5795, 39.8283];
  var VE_DEFAULT_ZOOM = 4;

  function isInAmericas(lat, lng) {
    if (typeof lat !== 'number' || typeof lng !== 'number' || Number.isNaN(lat) || Number.isNaN(lng)) {
      return false;
    }
    return lng >= -170 && lng <= -34 && lat >= -56 && lat <= 72;
  }

  function filterAmericasVenues(rows, fixAuNzLat) {
    if (!Array.isArray(rows)) return [];
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var venue = rows[i];
      var coords = resolveCoords(venue, fixAuNzLat);
      if (coords && isInAmericas(coords.lat, coords.lng)) {
        out.push(venue);
      }
    }
    return out;
  }

  function parseAllowedStateCodes(raw) {
    if (raw == null || String(raw).trim() === '') return null;
    var parts = String(raw).split(/[\s,]+/);
    var set = new Set();
    parts.forEach(function (part) {
      var code = String(part).trim().toUpperCase();
      if (/^[A-Z]{2}$/.test(code)) set.add(code);
    });
    return set.size ? set : null;
  }

  function resolveVenueStateCode(venue) {
    if (!venue) return '';
    var sc =
      venue.state_code != null && String(venue.state_code).trim() !== ''
        ? String(venue.state_code).trim()
        : venue.state != null && String(venue.state).trim() !== ''
          ? String(venue.state).trim()
          : '';
    if (sc.length === 2) return sc.toUpperCase();

    var cityKey = venue.city_key != null ? String(venue.city_key).trim().toLowerCase() : '';
    var cityKeyMatch = cityKey.match(/^us-([a-z]{2})-/);
    if (cityKeyMatch) return cityKeyMatch[1].toUpperCase();

    var address = venue.address != null ? String(venue.address) : '';
    var addressMatch =
      address.match(/,\s*([A-Z]{2})\s+\d{5}(?:-\d{4})?\b/) ||
      address.match(/,\s*([A-Z]{2})\s*,\s*USA?\b/i) ||
      address.match(/,\s*([A-Z]{2})\s+US\b/);
    if (addressMatch) return addressMatch[1].toUpperCase();
    return '';
  }

  function filterAllowedStateVenues(rows, allowedSet) {
    if (!allowedSet || !allowedSet.size) return rows || [];
    if (!Array.isArray(rows)) return [];
    return rows.filter(function (venue) {
      var stateCode = resolveVenueStateCode(venue);
      /* Unknown state: keep inventory row (empty address must not hide an active venue). */
      if (!stateCode) return true;
      return allowedSet.has(stateCode);
    });
  }

  function resolveCoords(venue, fixAuNzLat) {
    var lat = venue.lat != null && venue.lat !== '' ? parseFloat(String(venue.lat), 10) : NaN;
    var lng = venue.lng != null && venue.lng !== '' ? parseFloat(String(venue.lng), 10) : NaN;
    if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
      if (fixAuNzLat) {
        var n = maybeFixMisenteredSouthernLat(lat, lng);
        lat = n.lat;
        lng = n.lng;
      }
      return { lat: lat, lng: lng };
    }
    return null;
  }

  var VE_STORE_NAMES = {
    dallas: true,
    orlando: true
  };

  function isStoreVenue(venue) {
    if (!venue) return false;
    var name = venue.name != null ? String(venue.name).trim().toLowerCase() : '';
    if (name && VE_STORE_NAMES[name]) return true;
    var handle = venue.venue_handle != null ? String(venue.venue_handle).trim().toLowerCase() : '';
    return !!(handle && VE_STORE_NAMES[handle]);
  }

  function resolveMarkerKind(venue) {
    if (!venue) return 'popup';
    return isStoreVenue(venue) ? 'store' : 'popup';
  }

  var MAP_MARKER_SIZE = 32;

  function getMarkerImages(rootEl) {
    var root = rootEl || document.getElementById('venue-explorer');
    if (!root) {
      return { store: '', popup: '' };
    }
    return {
      store: (root.getAttribute('data-store-marker-image') || '').trim(),
      popup: (root.getAttribute('data-popup-marker-image') || '').trim()
    };
  }

  function markerImageTag(kind, size, rootEl) {
    var images = getMarkerImages(rootEl);
    var src = kind === 'popup' ? images.popup : images.store;
    var s = size != null ? size : MAP_MARKER_SIZE;
    if (!src) return '';
    return (
      '<img src="' +
      esc(src) +
      '" alt="" width="' +
      s +
      '" height="' +
      s +
      '" class="ve-marker-img" decoding="async" draggable="false">'
    );
  }

  function storeMarkerHtml() {
    return (
      '<div class="ve-marker-img-wrap" style="width:' +
      MAP_MARKER_SIZE +
      'px;height:' +
      MAP_MARKER_SIZE +
      'px;filter:drop-shadow(0 2px 6px rgba(0,0,0,.22))">' +
      markerImageTag('store', MAP_MARKER_SIZE) +
      '</div>'
    );
  }

  function popupMarkerHtml() {
    return (
      '<div class="ve-marker-img-wrap" style="width:' +
      MAP_MARKER_SIZE +
      'px;height:' +
      MAP_MARKER_SIZE +
      'px;filter:drop-shadow(0 2px 6px rgba(0,0,0,.22))">' +
      markerImageTag('popup', MAP_MARKER_SIZE) +
      '</div>'
    );
  }

  function createVenueMarkerElement(kindResolved) {
    /* Map markers: store/popup SVG (or theme marker PNG) only — never venue list_image. */
    var isPopup = kindResolved === 'popup';
    var html = isPopup ? popupMarkerHtml() : storeMarkerHtml();
    var wrap = document.createElement('div');
    wrap.className = 've-marker-wrap';
    wrap.innerHTML = html;
    wrap.style.cssText =
      'width:' + MAP_MARKER_SIZE + 'px;height:' + MAP_MARKER_SIZE + 'px;display:block;overflow:visible;';
    return wrap;
  }

  function workshopHref(venue, coords, workshopBase) {
    var path;
    if (workshopBase) {
      path = workshopBase;
    } else {
      path = '/pages/book-a-workshop';
    }
    var u;
    try {
      if (/^https?:\/\//i.test(path)) {
        u = new URL(path);
      } else {
        u = new URL(path, window.location.origin);
      }
    } catch (e) {
      u = new URL(window.location.origin + (path.charAt(0) === '/' ? path : '/' + path));
    }
    if (coords) {
      u.searchParams.set('lat', String(coords.lat));
      u.searchParams.set('lng', String(coords.lng));
    }
    var vh = venue.venue_handle || venue.handle || '';
    if (vh) u.searchParams.set('venue', String(vh));
    u.searchParams.set('wb_from', 'venue_explorer');
    var vid = venueIdStr(venue);
    if (vid) u.searchParams.set('venue_id', vid);
    if (venue && venue.name) u.searchParams.set('venue_name', String(venue.name));
    return u.href;
  }

  function getMarkerColors(rootEl) {
    var root = rootEl || document.getElementById('venue-explorer');
    if (!root) {
      return { store: '#042B39', popup: '#00A99E' };
    }
    var cs = getComputedStyle(root);
    return {
      store: cs.getPropertyValue('--ve-drawer-store').trim() || '#042B39',
      popup: cs.getPropertyValue('--ve-drawer-popup').trim() || '#00A99E'
    };
  }

  function getBrandColor(rootEl) {
    return getMarkerColors(rootEl).store;
  }

  function cartoVoyagerStyle() {
    return {
      version: 8,
      sources: {
        'carto-voyager': {
          type: 'raster',
          tiles: [
            'https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png',
            'https://b.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png',
            'https://c.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png',
            'https://d.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png'
          ],
          tileSize: 256,
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        }
      },
      layers: [
        {
          id: 'carto-voyager-layer',
          type: 'raster',
          source: 'carto-voyager',
          minzoom: 0,
          maxzoom: 22
        }
      ]
    };
  }

  function main() {
    var root = document.getElementById('venue-explorer');
    if (!root) return;

    var gmapsKey = root.getAttribute('data-google-maps-key');

    var venues = [];
    var pendingVenueSelectId = null;

    var listEl = document.getElementById('ve-list');
    var mapEl = document.getElementById('ve-map');
    var bodyRow = document.getElementById('ve-body');
    var listShell = root.querySelector('.ve-list-shell');
    var fullscreenBtn = document.getElementById('ve-map-fullscreen');

    function updateSidebarToggleA11y(isPanelOpen) {
      var btn = document.getElementById('ve-list-sidebar-toggle');
      if (!btn) return;
      if (MOBILE_MQ.matches) {
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-hidden', 'true');
        return;
      }
      btn.setAttribute('aria-expanded', isPanelOpen ? 'true' : 'false');
      btn.setAttribute(
        'title',
        isPanelOpen ? 'Close Our Venues' : 'Open Our Venues'
      );
      btn.setAttribute('aria-hidden', 'false');
      btn.setAttribute('tabindex', '0');
    }
    var searchInput = document.getElementById('ve-search');
    var locateBtn = document.getElementById('ve-locate');
    var searchBtn = document.getElementById('ve-search-btn');
    var workshopBase = root.getAttribute('data-workshop-url') || '';
    var searchSuggestionsEl = document.getElementById('ve-search-suggestions');
    var searchHighlightIndex = -1;
    var VE_SEARCH_MAX_RESULTS = 8;

    var venuesUrl = root.getAttribute('data-venues-url');

    var map;
    var mapResizeObserver = null;
    var markerMap = new Map();
    var activeVenuePopup = null;
    var sortLatLng = null;
    var locationSource = null;
    var mapListDistTimer = null;

    function getListDistanceRef() {
      if (sortLatLng) return sortLatLng;
      if (map && typeof map.getCenter === 'function') {
        var c = map.getCenter();
        return { lat: c.lat, lng: c.lng };
      }
      return null;
    }

    function scheduleListDistanceFromMap() {
      if (locationSource === 'geo' || locationSource === 'geo-approx' || locationSource === 'search') return;
      clearTimeout(mapListDistTimer);
      mapListDistTimer = setTimeout(function () {
        if (explorerInited) renderList(getDisplayVenues(), getListDistanceRef());
      }, 200);
    }
    var geoAutoChainRunning = false;
    var geoAutoSkipped = false;
    /* Manual taps bump manualGeoGen and autoGeoGen (cancels in-flight auto). Auto chain snapshots autoGeoGen at chain start. */
    var manualGeoGen = 0;
    var autoGeoGen = 0;
    var autoGeoScheduleTimer = null;
    var popupAfterFlyTimer = null;
    var mobileGeoGestureCleanup = null;
    var userMarker = null;
    var searchMarker = null;
    var selectedId = null;
    var explorerInited = false;
    var pseudoFullscreenActive = false;
    var coopDisabledByFullscreen = false;

    var markerColors = getMarkerColors(root);
    var fixAuNzLatRaw = root.getAttribute('data-fix-au-nz-lat');
    var fixAuNzLat = fixAuNzLatRaw !== 'false' && fixAuNzLatRaw !== '0';
    var allowedStates = parseAllowedStateCodes(root.getAttribute('data-allowed-states'));
    var upcomingOnlyRaw = root.getAttribute('data-upcoming-only');
    var upcomingOnly = upcomingOnlyRaw !== 'false' && upcomingOnlyRaw !== '0';

    /**
     * Map / search / list inventory.
     * When upcoming-only is on and workshop events are loaded, only venues with a future event show.
     */
    function getDisplayVenues() {
      var out = [];
      var requireUpcoming = upcomingOnly && venueWorkshopEvents.length > 0;
      for (var i = 0; i < venues.length; i++) {
        if (!resolveCoords(venues[i], fixAuNzLat)) continue;
        if (requireUpcoming && !venueHasUpcomingWorkshop(venues[i])) continue;
        out.push(venues[i]);
      }
      return out;
    }

    function closeVenuePopup() {
      if (activeVenuePopup) {
        activeVenuePopup.remove();
        activeVenuePopup = null;
      }
    }

    function openVenuePopupAt(venue, coords) {
      if (!map || typeof maplibregl === 'undefined') return;
      closeVenuePopup();
      var html = buildVenueMapPopupHtml(venue, coords, workshopBase);
      var p = new maplibregl.Popup({
        offset: [0, -36],
        closeButton: false,
        maxWidth: MOBILE_MQ.matches ? 'min(320px, calc(100vw - 48px))' : '340px',
        className: 've-maplibre-popup ve-maplibre-popup--enter'
      })
        .setLngLat([coords.lng, coords.lat])
        .setHTML(html);
      p.on('close', function () {
        activeVenuePopup = null;
      });
      p.addTo(map);
      activeVenuePopup = p;
      requestAnimationFrame(function () {
        var el = p.getElement && p.getElement();
        if (!el) return;
        el.classList.add('ve-maplibre-popup--visible');
        var closeBtn = el.querySelector('.ve-map-popup__close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeVenuePopup();
          });
        }
        var active = document.activeElement;
        if (active && el.contains(active) && typeof active.blur === 'function') {
          active.blur();
        }
      });
    }

    function userMarkerElement() {
      var el = document.createElement('div');
      el.className = 've-marker-wrap';
      el.innerHTML =
        '<div style="width:12px;height:12px;border-radius:50%;background:#00A99E;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.35);"></div>';
      return el;
    }

    function scheduleMapResize() {
      if (!map) return;
      function run() {
        try {
          map.resize();
        } catch (err) {
          /* ignore */
        }
      }
      run();
      requestAnimationFrame(function () {
        run();
        requestAnimationFrame(run);
      });
    }

    function getFullscreenElement() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement ||
        null
      );
    }

    function canNativeFullscreen() {
      if (!bodyRow) return false;
      return !!(
        bodyRow.requestFullscreen ||
        bodyRow.webkitRequestFullscreen ||
        bodyRow.mozRequestFullScreen ||
        bodyRow.msRequestFullscreen
      );
    }

    function requestNativeFullscreen() {
      if (!bodyRow) return false;
      var fn =
        bodyRow.requestFullscreen ||
        bodyRow.webkitRequestFullscreen ||
        bodyRow.mozRequestFullScreen ||
        bodyRow.msRequestFullscreen;
      if (!fn) return false;
      try {
        var out = fn.call(bodyRow);
        if (out && typeof out.then === 'function') {
          out.catch(function () {
            /* ignore, fallback handled by caller */
          });
        }
        return true;
      } catch (e) {
        return false;
      }
    }

    function exitNativeFullscreen() {
      var fn =
        document.exitFullscreen ||
        document.webkitExitFullscreen ||
        document.mozCancelFullScreen ||
        document.msExitFullscreen;
      if (!fn) return false;
      try {
        var out = fn.call(document);
        if (out && typeof out.then === 'function') {
          out.catch(function () {
            /* ignore */
          });
        }
        return true;
      } catch (e) {
        return false;
      }
    }

    function setPseudoFullscreen(active) {
      pseudoFullscreenActive = !!active;
      if (pseudoFullscreenActive) {
        root.classList.add('ve--pseudo-fullscreen');
        document.documentElement.classList.add('ve-no-scroll');
        document.body.classList.add('ve-no-scroll');
      } else {
        root.classList.remove('ve--pseudo-fullscreen');
        document.documentElement.classList.remove('ve-no-scroll');
        document.body.classList.remove('ve-no-scroll');
      }
      setTimeout(scheduleMapResize, 0);
      setTimeout(scheduleMapResize, 200);
    }

    function isFullscreenActive() {
      var fsEl = getFullscreenElement();
      var nativeActive = !!(fsEl && bodyRow && fsEl === bodyRow);
      return nativeActive || pseudoFullscreenActive;
    }

    function syncFullscreenUi() {
      var active = isFullscreenActive();
      root.classList.toggle('ve--is-fullscreen', active);
      try {
        var cg = map && map.cooperativeGestures;
        if (cg && typeof cg.disable === 'function' && typeof cg.enable === 'function') {
          if (active) {
            cg.disable();
            coopDisabledByFullscreen = true;
          } else if (coopDisabledByFullscreen) {
            cg.enable();
            coopDisabledByFullscreen = false;
          }
        }
      } catch (errCoopFs) {
        /* ignore */
      }
      if (!fullscreenBtn) return;
      fullscreenBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
      fullscreenBtn.setAttribute(
        'aria-label',
        active ? 'Exit fullscreen map view' : 'Enter fullscreen map view'
      );
      fullscreenBtn.setAttribute('title', active ? 'Exit fullscreen' : 'Fullscreen');
    }

    function exitFullscreenView() {
      var fsEl = getFullscreenElement();
      if (fsEl && bodyRow && fsEl === bodyRow) {
        exitNativeFullscreen();
      }
      if (pseudoFullscreenActive) {
        setPseudoFullscreen(false);
      }
      syncFullscreenUi();
    }

    function enterFullscreenView() {
      /* Mobile browsers can hide custom controls in native fullscreen; use stable pseudo fullscreen on handsets. */
      var preferPseudo = MOBILE_MQ.matches || isTouchHandsetForMapGestures();
      var enteredNative = false;
      if (!preferPseudo) {
        enteredNative = canNativeFullscreen() && requestNativeFullscreen();
      }
      if (!enteredNative) {
        setPseudoFullscreen(true);
      }
      syncFullscreenUi();
      setTimeout(scheduleMapResize, 50);
      setTimeout(scheduleMapResize, 260);
    }

    function toggleFullscreenView() {
      if (isFullscreenActive()) {
        exitFullscreenView();
      } else {
        enterFullscreenView();
      }
    }

    function mapJumpTo(lat, lng, zoom) {
      if (!map) return;
      map.jumpTo({ center: [lng, lat], zoom: zoom, essential: true });
      scheduleMapResize();
    }

    /** Reference location (GPS / search): animate from world view to a usable street-area zoom. */
    var VE_REF_ZOOM_GEO = 11.5;
    var VE_REF_EASE_MS = 2200;
    var venueFlyTimer = null;

    function mapEaseTo(lat, lng, zoom, durationMs) {
      if (!map) return;
      var d = durationMs != null ? durationMs : VE_REF_EASE_MS;
      try {
        if (typeof map.easeTo === 'function') {
          map.easeTo({
            center: [lng, lat],
            zoom: zoom,
            duration: d,
            essential: true
          });
        } else {
          mapJumpTo(lat, lng, zoom);
        }
      } catch (errEase) {
        mapJumpTo(lat, lng, zoom);
      }
      scheduleMapResize();
    }

    function mapEaseToVenueTwoStage(lat, lng) {
      if (!map) return;
      if (venueFlyTimer) {
        clearTimeout(venueFlyTimer);
        venueFlyTimer = null;
      }
      var currentZoom = typeof map.getZoom === 'function' ? map.getZoom() : 2;
      var currentCenter = typeof map.getCenter === 'function' ? map.getCenter() : { lat: lat, lng: lng };
      var zoomOut = 4.2; // country-level pullback
      var midZoom = 7.6;
      var finalZoom = Math.min(Math.max(currentZoom, 11.8), 14);

      // If map is already farther out than zoomOut, skip pull-back.
      var shouldPullBack = currentZoom > zoomOut;

      if (shouldPullBack) {
        // 1) Pull back from current location.
        mapEaseTo(currentCenter.lat, currentCenter.lng, zoomOut, 1050);
        // 2) Travel to target while still relatively zoomed out.
        venueFlyTimer = setTimeout(function () {
          mapEaseTo(lat, lng, midZoom, 1250);
          // 3) Final slow zoom-in on target.
          venueFlyTimer = setTimeout(function () {
            venueFlyTimer = null;
            mapEaseTo(lat, lng, finalZoom, 1450);
          }, 1320);
        }, 1080);
      } else {
        // Already zoomed out enough: go to target first, then zoom in.
        mapEaseTo(lat, lng, midZoom, 1250);
        venueFlyTimer = setTimeout(function () {
          venueFlyTimer = null;
          mapEaseTo(lat, lng, finalZoom, 1450);
        }, 1320);
      }
    }

    function mapStyleReady() {
      if (!map) return false;
      if (typeof map.isStyleLoaded === 'function') return map.isStyleLoaded();
      if (typeof map.loaded === 'function') return map.loaded();
      return true;
    }

    function whenMapStyleReady(fn) {
      if (!map || typeof fn !== 'function') return;
      if (mapStyleReady()) {
        fn();
        return;
      }
      map.once('load', fn);
    }

    function setLocateBusy(busy) {
      var buttons = [locateBtn, document.getElementById('ve-locate-fab')];
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        if (!btn) continue;
        btn.disabled = !!busy;
        btn.classList.toggle('ve-locate--busy', !!busy);
        btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      }
    }

    function geolocationErrorMessage(err) {
      var code = err && err.code ? err.code : 0;
      if (code === 1) {
        return 'Location permission denied. Allow location for this site in your browser settings.';
      }
      if (code === 2) {
        var macHint =
          /Mac|Macintosh/i.test(navigator.userAgent || '')
            ? ' On Mac: open System Settings → Privacy & Security → Location Services, enable Location Services and allow your browser. Then reload and try again.'
            : ' Enable location services on your device, or search for your address instead.';
        return 'Location unavailable (device could not determine your position).' + macHint;
      }
      if (code === 3) return 'Location request timed out. Try again, or search for your address.';
      return 'Could not get your location. Try again or search for your address.';
    }

    function manualLocateOptions(attempt, mobile) {
      if (mobile) {
        if (attempt === 0) {
          return { enableHighAccuracy: false, timeout: 22000, maximumAge: 300000 };
        }
        if (attempt === 1) {
          return { enableHighAccuracy: true, timeout: 32000, maximumAge: 0 };
        }
        return null;
      }
      /* Desktop / Mac: low accuracy first — CoreLocation Wi‑Fi fix fails less often than GPS. */
      if (attempt === 0) {
        return { enableHighAccuracy: false, timeout: 12000, maximumAge: 300000 };
      }
      if (attempt === 1) {
        return { enableHighAccuracy: false, timeout: 18000, maximumAge: 60000 };
      }
      if (attempt === 2) {
        return { enableHighAccuracy: true, timeout: 22000, maximumAge: 0 };
      }
      return null;
    }

    function watchPositionOnce(options, timeoutMs, onSuccess, onError) {
      if (!navigator.geolocation || typeof navigator.geolocation.watchPosition !== 'function') {
        onError({ code: 2 });
        return;
      }
      var watchId = null;
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        if (watchId != null) navigator.geolocation.clearWatch(watchId);
        onError({ code: 3 });
      }, timeoutMs);
      watchId = navigator.geolocation.watchPosition(
        function (pos) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          navigator.geolocation.clearWatch(watchId);
          onSuccess(pos);
        },
        function (err) {
          if (settled) return;
          if (err && err.code === 1) {
            settled = true;
            clearTimeout(timer);
            navigator.geolocation.clearWatch(watchId);
            onError(err);
          }
        },
        options
      );
    }

    function tryGoogleNetworkGeolocate() {
      if (!gmapsKey) return Promise.reject(new Error('no key'));
      return fetch(
        'https://www.googleapis.com/geolocation/v1/geolocate?key=' + encodeURIComponent(gmapsKey),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: '{}'
        }
      ).then(function (r) {
        if (!r.ok) throw new Error('google geolocate failed');
        return r.json();
      }).then(function (data) {
        if (!data || !data.location) throw new Error('no google location');
        return {
          coords: {
            latitude: data.location.lat,
            longitude: data.location.lng,
            accuracy: data.accuracy || 50000
          }
        };
      });
    }

    function tryIpNetworkGeolocate() {
      return fetch('https://ipapi.co/json/', { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('ipapi failed');
        return r.json();
      }).then(function (data) {
        if (!data || data.error || data.latitude == null || data.longitude == null) {
          throw new Error('no ipapi coords');
        }
        return {
          coords: {
            latitude: parseFloat(data.latitude),
            longitude: parseFloat(data.longitude),
            accuracy: 50000
          }
        };
      });
    }

    function tryGeoJsNetworkGeolocate() {
      return fetch('https://get.geojs.io/v1/ip/geo.json', { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('geojs failed');
        return r.json();
      }).then(function (data) {
        if (!data || data.latitude == null || data.longitude == null) {
          throw new Error('no geojs coords');
        }
        return {
          coords: {
            latitude: parseFloat(data.latitude),
            longitude: parseFloat(data.longitude),
            accuracy: 50000
          }
        };
      });
    }

    /** Fallback when GPS/CoreLocation fails despite browser permission (common on Mac). */
    function tryNetworkLocationFallback() {
      return tryGoogleNetworkGeolocate()
        .catch(function () {
          return tryIpNetworkGeolocate();
        })
        .catch(function () {
          return tryGeoJsNetworkGeolocate();
        });
    }

    function showLocateStatus(message, isError) {
      if (!isError || !message) return;
      if (locateBtn) locateBtn.setAttribute('title', message);
      var fab = document.getElementById('ve-locate-fab');
      if (fab) fab.setAttribute('title', message);
    }

    function applyReferenceToMapWhenReady() {
      if (!sortLatLng || typeof maplibregl === 'undefined') return;
      if (!map) {
        if (explorerInited) initMap();
        return;
      }
      function apply() {
        if (!map || !sortLatLng) return;
        if (locationSource === 'geo' || locationSource === 'geo-approx') {
          var refZoom = sortLatLng.approximate
            ? Math.max(VE_REF_ZOOM_GEO - 2.5, 8)
            : VE_REF_ZOOM_GEO;
          setUserMarker(sortLatLng);
          mapEaseTo(sortLatLng.lat, sortLatLng.lng, refZoom, VE_REF_EASE_MS);
        }
        /* locationSource === 'search': inventory city pick — selectVenue owns camera/popup. */
      }
      whenMapStyleReady(apply);
    }

    function setupCooperativeGesturesTouchUnlock() {
      if (!isTouchHandsetForMapGestures() || !map || !mapEl) return;
      var cg = map.cooperativeGestures;
      if (!cg || typeof cg.disable !== 'function' || typeof cg.enable !== 'function') return;

      try {
        cg.disable();
      } catch (err1) {
        /* ignore */
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          try {
            if (map && map.cooperativeGestures && map.cooperativeGestures.disable) {
              map.cooperativeGestures.disable();
            }
          } catch (err2) {
            /* ignore */
          }
        });
      });

      if (mapEl.getAttribute('data-ve-coop-unlock') === '1') return;
      mapEl.setAttribute('data-ve-coop-unlock', '1');

      var container =
        typeof map.getCanvasContainer === 'function' ? map.getCanvasContainer() : mapEl;
      if (!container) return;

      var armed = false;
      function detachAndEnableCoop() {
        container.removeEventListener('touchstart', onFirstMapInteraction, true);
        container.removeEventListener('pointerdown', onFirstMapInteraction, true);
        container.removeEventListener('touchend', onFirstMapInteraction, true);
        try {
          if (map && map.cooperativeGestures && map.cooperativeGestures.enable) {
            map.cooperativeGestures.enable();
          }
        } catch (err3) {
          /* ignore */
        }
      }
      function onFirstMapInteraction(ev) {
        if (armed) return;
        var t = ev.target;
        if (!t || !container.contains(t)) return;
        if (elementClosest(t, '.maplibregl-ctrl')) return;
        armed = true;
        detachAndEnableCoop();
      }

      container.addEventListener('touchstart', onFirstMapInteraction, { capture: true, passive: true });
      container.addEventListener('pointerdown', onFirstMapInteraction, { capture: true, passive: true });
      container.addEventListener('touchend', onFirstMapInteraction, { capture: true, passive: true });
    }

    function initMap() {
      if (map || typeof maplibregl === 'undefined') return;
      var workerUrl = root.getAttribute('data-maplibre-worker-url');
      if (workerUrl && typeof maplibregl.setWorkerUrl === 'function') {
        maplibregl.setWorkerUrl(workerUrl);
      }
      /* Default: contiguous US mainland view */
      map = new maplibregl.Map({
        container: mapEl,
        style: cartoVoyagerStyle(),
        center: VE_DEFAULT_CENTER,
        zoom: VE_DEFAULT_ZOOM,
        cooperativeGestures: true,
        minZoom: 1,
        maxZoom: 22,
        renderWorldCopies: true,
        attributionControl: true
      });

      if (isTouchHandsetForMapGestures() && map.cooperativeGestures && typeof map.cooperativeGestures.disable === 'function') {
        try {
          map.cooperativeGestures.disable();
        } catch (errCoop) {
          /* ignore */
        }
      }

      map.on('load', function () {
        var compassBtn = document.getElementById('ve-map-compass');
        var compassNeedle = compassBtn ? compassBtn.querySelector('.ve-map-compass__needle') : null;
        function bearingNeedsReset() {
          if (!map) return false;
          var b = typeof map.getBearing === 'function' ? map.getBearing() : 0;
          if (Math.abs(b) > 1.5) return true;
          var p = typeof map.getPitch === 'function' ? map.getPitch() : 0;
          return Math.abs(p) > 1.5;
        }
        function syncCompassControl() {
          if (!compassBtn || !map) return;
          var show = bearingNeedsReset();
          if (show) {
            compassBtn.removeAttribute('hidden');
            compassBtn.setAttribute('aria-hidden', 'false');
          } else {
            compassBtn.setAttribute('hidden', '');
            compassBtn.setAttribute('aria-hidden', 'true');
          }
          if (compassNeedle && typeof map.getBearing === 'function') {
            var deg = -map.getBearing();
            compassNeedle.style.transform = 'rotate(' + deg + 'deg)';
            compassNeedle.style.transformOrigin = '12px 12px';
          }
        }
        if (compassBtn) {
          compassBtn.addEventListener('click', function () {
            if (!map) return;
            try {
              if (typeof map.easeTo === 'function') {
                map.easeTo({ bearing: 0, pitch: 0, duration: 450, essential: true });
              } else {
                if (typeof map.setBearing === 'function') map.setBearing(0);
                if (typeof map.setPitch === 'function') map.setPitch(0);
              }
            } catch (errC) {
              /* ignore */
            }
            setTimeout(syncCompassControl, 500);
          });
          map.on('rotate', syncCompassControl);
          map.on('pitchend', syncCompassControl);
          map.on('moveend', syncCompassControl);
          syncCompassControl();
        }

        scheduleMapResize();
        if (typeof ResizeObserver !== 'undefined' && mapEl) {
          if (mapResizeObserver) {
            mapResizeObserver.disconnect();
          }
          mapResizeObserver = new ResizeObserver(function () {
            scheduleMapResize();
          });
          mapResizeObserver.observe(mapEl);
        }
        function onWinLoad() {
          window.removeEventListener('load', onWinLoad);
          scheduleMapResize();
        }
        if (document.readyState === 'complete') {
          setTimeout(scheduleMapResize, 0);
        } else {
          window.addEventListener('load', onWinLoad);
        }
        syncReferenceMarkerFromState();
        renderList(getDisplayVenues(), getListDistanceRef());
        map.on('moveend', scheduleListDistanceFromMap);

        setupCooperativeGesturesTouchUnlock();
      });

      map.on('click', function (e) {
        var t = e.originalEvent && e.originalEvent.target;
        if (t && (elementClosest(t, '.maplibregl-marker') || elementClosest(t, '.maplibregl-popup'))) return;
        closeVenuePopup();
        if (MOBILE_MQ.matches) {
          closeMobileListPanel();
        }
      });

      syncMapMarkersFromDisplay();

      syncReferenceMarkerFromState();

      setupVenueInventorySearch();

      if (pendingVenueSelectId) {
        var pendingId = pendingVenueSelectId;
        pendingVenueSelectId = null;
        selectVenue(pendingId, { fly: true, openPopup: true });
      }

      scheduleMapResize();
      setTimeout(scheduleMapResize, 150);
      setTimeout(scheduleMapResize, 500);
    }

    /** Keep map pins in sync with getDisplayVenues() (list can grow after API enrich). */
    function syncMapMarkersFromDisplay() {
      if (!map || typeof maplibregl === 'undefined') return;
      var display = getDisplayVenues();
      var keep = Object.create(null);
      display.forEach(function (venue) {
        var coords = resolveCoords(venue, fixAuNzLat);
        if (!coords) return;
        var id = venueIdStr(venue);
        if (!id) return;
        keep[id] = true;
        var existing = markerMap.get(id);
        if (existing) {
          existing.venue = venue;
          existing.coords = coords;
          try {
            existing.marker.setLngLat([coords.lng, coords.lat]);
          } catch (_) {}
          return;
        }
        var el = createVenueMarkerElement(resolveMarkerKind(venue));
        var marker = new maplibregl.Marker({
          element: el,
          anchor: 'center'
        })
          .setLngLat([coords.lng, coords.lat])
          .addTo(map);
        el.addEventListener('click', function (e) {
          e.stopPropagation();
          selectVenue(id, { fly: true, openPopup: true });
        });
        markerMap.set(id, { marker: marker, venue: venue, coords: coords });
      });
      markerMap.forEach(function (entry, id) {
        if (keep[id]) return;
        try {
          if (entry && entry.marker) entry.marker.remove();
        } catch (_) {}
        markerMap.delete(id);
      });
    }

    function clearSearchMarker() {
      if (searchMarker) {
        searchMarker.remove();
        searchMarker = null;
      }
    }

    function clearUserMarker() {
      if (userMarker) {
        userMarker.remove();
        userMarker = null;
      }
    }

    function syncReferenceMarkerFromState() {
      applyReferenceToMapWhenReady();
    }

    function ensureSearchSuggestionsEl() {
      if (searchSuggestionsEl) return searchSuggestionsEl;
      var wrap = root.querySelector('.ve-search-bar-wrap');
      if (!wrap) return null;
      searchSuggestionsEl = document.createElement('ul');
      searchSuggestionsEl.id = 've-search-suggestions';
      searchSuggestionsEl.className = 've-search-suggestions';
      searchSuggestionsEl.setAttribute('role', 'listbox');
      searchSuggestionsEl.setAttribute('aria-label', 'Workshop cities');
      searchSuggestionsEl.hidden = true;
      wrap.appendChild(searchSuggestionsEl);
      return searchSuggestionsEl;
    }

    function hideSearchSuggestions() {
      var el = ensureSearchSuggestionsEl();
      if (!el) return;
      el.hidden = true;
      el.innerHTML = '';
      searchHighlightIndex = -1;
      if (searchInput) searchInput.removeAttribute('aria-activedescendant');
    }

    function applySearchHighlight() {
      var el = ensureSearchSuggestionsEl();
      if (!el) return;
      var nodes = el.querySelectorAll('.ve-search-suggestion');
      for (var i = 0; i < nodes.length; i++) {
        var active = i === searchHighlightIndex;
        nodes[i].classList.toggle('is-active', active);
        nodes[i].setAttribute('aria-selected', active ? 'true' : 'false');
        if (active && searchInput) {
          searchInput.setAttribute('aria-activedescendant', nodes[i].id);
        }
      }
      if (searchHighlightIndex < 0 && searchInput) {
        searchInput.removeAttribute('aria-activedescendant');
      }
    }

    function renderSearchSuggestions(scored) {
      var el = ensureSearchSuggestionsEl();
      if (!el) return;
      if (!scored || !scored.length) {
        hideSearchSuggestions();
        return;
      }
      var html = '';
      scored.slice(0, VE_SEARCH_MAX_RESULTS).forEach(function (row, idx) {
        var venue = row.venue;
        var id = venueIdStr(venue);
        if (!id) return;
        var label = row.label || formatVenueSearchLabel(venue);
        var address = venue.address != null ? String(venue.address).trim() : '';
        html +=
          '<li class="ve-search-suggestion" role="option" id="ve-search-opt-' +
          idx +
          '" data-venue-id="' +
          esc(id) +
          '" aria-selected="false">' +
          '<span class="ve-search-suggestion__label">' +
          esc(label) +
          '</span>' +
          (address
            ? '<span class="ve-search-suggestion__meta">' + esc(address) + '</span>'
            : '') +
          '</li>';
      });
      el.innerHTML = html;
      el.hidden = !html;
      searchHighlightIndex = html ? 0 : -1;
      applySearchHighlight();
    }

    function updateSearchSuggestionsFromInput() {
      if (!searchInput) return;
      var q = (searchInput.value || '').trim();
      if (q.length < 2) {
        hideSearchSuggestions();
        return;
      }
      var scored = filterVenuesBySearchQuery(getDisplayVenues(), q);
      renderSearchSuggestions(scored);
    }

    function selectVenueFromSearch(venue) {
      if (!venue) return;
      var id = venueIdStr(venue);
      if (!id) return;
      var coords = resolveCoords(venue, fixAuNzLat);
      hideSearchSuggestions();
      if (searchInput) {
        searchInput.value = formatVenueSearchLabel(venue);
        searchInput.blur();
        searchInput.setAttribute('aria-expanded', 'false');
      }
      manualGeoGen++;
      autoGeoGen++;
      clearUserMarker();
      clearSearchMarker();
      if (coords) {
        sortLatLng = coords;
        locationSource = 'search';
        renderList(getDisplayVenues(), sortLatLng);
      }
      if (!map || !markerMap.has(id)) {
        pendingVenueSelectId = id;
        return;
      }
      selectVenue(id, { fly: true, openPopup: true });
    }

    function selectHighlightedSearchSuggestion() {
      var el = ensureSearchSuggestionsEl();
      if (!el || el.hidden) return false;
      var nodes = el.querySelectorAll('.ve-search-suggestion');
      if (!nodes.length) return false;
      var idx = searchHighlightIndex >= 0 ? searchHighlightIndex : 0;
      var node = nodes[idx];
      if (!node) return false;
      var vid = node.getAttribute('data-venue-id');
      var entry = markerMap.get(String(vid));
      var venue = entry && entry.venue;
      if (!venue) {
        var rows = getDisplayVenues();
        for (var ri = 0; ri < rows.length; ri++) {
          if (venueIdStr(rows[ri]) === String(vid)) {
            venue = rows[ri];
            break;
          }
        }
      }
      if (!venue) return false;
      selectVenueFromSearch(venue);
      return true;
    }

    function onSearchButtonClick() {
      if (!searchInput) return;
      if (selectHighlightedSearchSuggestion()) return;
      var q = (searchInput.value || '').trim();
      if (!q) return;
      var scored = filterVenuesBySearchQuery(getDisplayVenues(), q);
      if (!scored.length) {
        renderSearchSuggestions([]);
        return;
      }
      if (scored.length === 1 || scored[0].score >= 200) {
        selectVenueFromSearch(scored[0].venue);
        return;
      }
      renderSearchSuggestions(scored);
    }

    function setupVenueInventorySearch() {
      if (!searchInput || searchInput.getAttribute('data-ve-inventory-search') === '1') return;
      searchInput.setAttribute('data-ve-inventory-search', '1');
      searchInput.setAttribute('autocomplete', 'off');
      searchInput.setAttribute('role', 'combobox');
      searchInput.setAttribute('aria-autocomplete', 'list');
      searchInput.setAttribute('aria-expanded', 'false');
      searchInput.setAttribute('aria-controls', 've-search-suggestions');
      ensureSearchSuggestionsEl();

      searchInput.addEventListener('input', function () {
        updateSearchSuggestionsFromInput();
        var el = ensureSearchSuggestionsEl();
        searchInput.setAttribute('aria-expanded', el && !el.hidden ? 'true' : 'false');
      });

      searchInput.addEventListener('focus', function () {
        updateSearchSuggestionsFromInput();
      });

      searchInput.addEventListener('keydown', function (e) {
        var el = ensureSearchSuggestionsEl();
        var open = el && !el.hidden;
        var nodes = open ? el.querySelectorAll('.ve-search-suggestion') : [];
        if (e.key === 'ArrowDown' && nodes.length) {
          e.preventDefault();
          searchHighlightIndex = Math.min(nodes.length - 1, searchHighlightIndex + 1);
          if (searchHighlightIndex < 0) searchHighlightIndex = 0;
          applySearchHighlight();
          return;
        }
        if (e.key === 'ArrowUp' && nodes.length) {
          e.preventDefault();
          searchHighlightIndex = Math.max(0, searchHighlightIndex - 1);
          applySearchHighlight();
          return;
        }
        if (e.key === 'Escape') {
          hideSearchSuggestions();
          searchInput.setAttribute('aria-expanded', 'false');
          return;
        }
        if (e.key === 'Enter') {
          e.preventDefault();
          onSearchButtonClick();
        }
      });

      var suggestionsHost = ensureSearchSuggestionsEl();
      if (suggestionsHost && suggestionsHost.getAttribute('data-ve-bound') !== '1') {
        suggestionsHost.setAttribute('data-ve-bound', '1');
        suggestionsHost.addEventListener('mousedown', function (e) {
          var item = elementClosest(e.target, '.ve-search-suggestion');
          if (!item) return;
          e.preventDefault();
          var vid = item.getAttribute('data-venue-id');
          var venue = null;
          var displayRows = getDisplayVenues();
          for (var vi = 0; vi < displayRows.length; vi++) {
            if (venueIdStr(displayRows[vi]) === String(vid)) {
              venue = displayRows[vi];
              break;
            }
          }
          if (venue) selectVenueFromSearch(venue);
        });
      }

      if (root.getAttribute('data-ve-search-doc-click') !== '1') {
        root.setAttribute('data-ve-search-doc-click', '1');
        document.addEventListener('click', function (e) {
          if (!searchInput) return;
          var wrap = root.querySelector('.ve-search-bar-wrap');
          if (wrap && wrap.contains(e.target)) return;
          hideSearchSuggestions();
          searchInput.setAttribute('aria-expanded', 'false');
        });
      }
    }

    function setUserMarker(latlng) {
      if (!map) return;
      if (userMarker) {
        userMarker.setLngLat([latlng.lng, latlng.lat]);
      } else {
        userMarker = new maplibregl.Marker({ element: userMarkerElement() })
          .setLngLat([latlng.lng, latlng.lat])
          .setPopup(new maplibregl.Popup({ offset: 10, className: 've-maplibre-popup--hint' }).setText('You are here'))
          .addTo(map);
      }
    }

    function onLocated(pos, meta) {
      if (mobileGeoGestureCleanup) {
        mobileGeoGestureCleanup();
        mobileGeoGestureCleanup = null;
      }
      setLocateBusy(false);
      clearSearchMarker();
      var approximate = !!(meta && meta.approximate);
      sortLatLng = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
        approximate: approximate
      };
      locationSource = approximate ? 'geo-approx' : 'geo';
      if (!approximate && locateBtn) {
        locateBtn.setAttribute('title', 'Use my location');
        var fabReset = document.getElementById('ve-locate-fab');
        if (fabReset) fabReset.setAttribute('title', 'Find my location');
      }
      renderList(getDisplayVenues(), sortLatLng);
      applyReferenceToMapWhenReady();
    }

    function onDenied(err, fromManual) {
      if (fromManual) {
        setLocateBusy(false);
        showLocateStatus(geolocationErrorMessage(err), true);
      }
      if (!fromManual) {
        sortLatLng = null;
        locationSource = null;
        clearUserMarker();
        clearSearchMarker();
        renderList(getDisplayVenues(), getListDistanceRef());
      }
    }

    function geolocationOptionsForLocate() {
      return manualLocateOptions(0, MOBILE_MQ.matches);
    }

    /**
     * Automatic geolocation on load — mobile only. Desktop/Mac CoreLocation often fails
     * silently (kCLErrorLocationUnknown); require an explicit button tap instead.
     */
    function runGeoAutoChain(attempt, chainGenSnap) {
      if (!MOBILE_MQ.matches) return;
      if (geoAutoSkipped) return;
      if (!navigator.geolocation) {
        onDenied(null, false);
        return;
      }
      if (locationSource === 'search') return;
      if (sortLatLng && locationSource === 'geo') return;

      var maxTries = 3;
      if (attempt >= maxTries) {
        geoAutoChainRunning = false;
        return;
      }

      if (attempt === 0) {
        if (geoAutoChainRunning) return;
        geoAutoChainRunning = true;
        chainGenSnap = autoGeoGen;
      }

      if (chainGenSnap == null) {
        geoAutoChainRunning = false;
        return;
      }

      var timeoutsMobile = [18000, 24000, 30000];
      var opts = {
        enableHighAccuracy: attempt >= 1,
        timeout: timeoutsMobile[attempt] || 30000,
        maximumAge: attempt === 0 ? 120000 : 300000
      };

      navigator.geolocation.getCurrentPosition(
        function (pos) {
          if (chainGenSnap !== autoGeoGen) {
            geoAutoChainRunning = false;
            return;
          }
          geoAutoChainRunning = false;
          onLocated(pos);
        },
        function (err) {
          if (chainGenSnap !== autoGeoGen) {
            geoAutoChainRunning = false;
            return;
          }
          var code = err && err.code ? err.code : 0;
          if (code === 1 || code === 2) {
            geoAutoChainRunning = false;
            geoAutoSkipped = true;
            if (code === 1) onDenied(err, false);
            return;
          }
          if (attempt < maxTries - 1) {
            setTimeout(function () {
              runGeoAutoChain(attempt + 1, chainGenSnap);
            }, 600 + attempt * 300);
          } else {
            geoAutoChainRunning = false;
          }
        },
        opts
      );
    }

    function scheduleAutomaticGeolocation(delayMs) {
      if (!MOBILE_MQ.matches || geoAutoSkipped) return;
      var d = delayMs != null ? delayMs : 0;
      if (autoGeoScheduleTimer) {
        clearTimeout(autoGeoScheduleTimer);
        autoGeoScheduleTimer = null;
      }
      autoGeoScheduleTimer = setTimeout(function () {
        autoGeoScheduleTimer = null;
        runGeoAutoChain(0);
      }, d);
    }

    var geoReliabilityHooksBound = false;
    function bindGeolocationReliabilityHooks() {
      if (geoReliabilityHooksBound) return;
      geoReliabilityHooksBound = true;

      function schedulePostLoadMobileGeo() {
        if (!MOBILE_MQ.matches || !navigator.geolocation) return;
        setTimeout(function () {
          if (locationSource === 'search') return;
          if (sortLatLng && locationSource === 'geo') return;
          scheduleAutomaticGeolocation(0);
        }, 700);
      }

      /* Fetch often finishes after window "load" — a late addEventListener("load") never runs. */
      if (document.readyState === 'complete') {
        schedulePostLoadMobileGeo();
      } else {
        window.addEventListener('load', schedulePostLoadMobileGeo);
      }

      document.addEventListener('visibilitychange', function () {
        if (!MOBILE_MQ.matches) return;
        if (document.visibilityState !== 'visible') return;
        if (!navigator.geolocation || geoAutoSkipped) return;
        if (locationSource === 'search') return;
        if (sortLatLng && locationSource === 'geo') return;
        scheduleAutomaticGeolocation(250);
      });

      /* Normal reload sets persisted=false; still re-queue auto geo after refresh. */
      window.addEventListener('pageshow', function (ev) {
        if (!MOBILE_MQ.matches) return;
        if (!navigator.geolocation || geoAutoSkipped) return;
        if (locationSource === 'search') return;
        if (sortLatLng && locationSource === 'geo') return;
        var delay = ev.persisted ? 200 : 1000;
        scheduleAutomaticGeolocation(delay);
      });
    }

    /**
     * iOS/Safari often blocks or no-ops geolocation until there is a user gesture.
     * First tap/click anywhere on the explorer (map, search, list) reuses the same path as "Use my location".
     */
    function bindMobileFirstInteractionGeolocation() {
      if (!MOBILE_MQ.matches) return;
      function shouldTriggerGestureGeo(el) {
        if (!el || typeof el.closest !== 'function') return false;
        if (el.closest('.ve-search-bar-wrap')) return false;
        if (el.closest('#ve-locate-fab')) return false;
        return !!el.closest(
          '#ve-map, .ve-map-stage, .ve-list-panel, #ve-list, .ve-mobile-toggle, .ve-legend-mobile'
        );
      }
      function detach() {
        root.removeEventListener('touchstart', onTouch, true);
        root.removeEventListener('click', onClick, true);
        if (mobileGeoGestureCleanup === detach) {
          mobileGeoGestureCleanup = null;
        }
      }
      function maybeRequestFromGesture() {
        if (locationSource === 'search') return;
        if (sortLatLng && locationSource === 'geo') return;
        if (!navigator.geolocation) return;
        requestUserGeolocation();
      }
      function onTouch(ev) {
        if (!shouldTriggerGestureGeo(ev.target)) return;
        detach();
        maybeRequestFromGesture();
      }
      function onClick(ev) {
        if (!shouldTriggerGestureGeo(ev.target)) return;
        detach();
        maybeRequestFromGesture();
      }
      mobileGeoGestureCleanup = detach;
      root.addEventListener('touchstart', onTouch, { capture: true, passive: true });
      root.addEventListener('click', onClick, { capture: true });
    }

    var NETWORK_LOCATE_META = {
      approximate: true,
      message:
        'Showing approximate location from your network. For exact GPS, enable Location Services for your browser in System Settings.'
    };

    /**
     * Desktop / Mac: GPS often hangs ~15s then fails (CoreLocation). Run network lookup in
     * parallel with one short GPS try — whichever succeeds first (GPS preferred if it wins).
     */
    function requestDesktopLocateFast(myManual) {
      var settled = false;
      var gpsFinished = false;
      var networkFinished = false;

      function succeed(pos, meta) {
        if (myManual !== manualGeoGen) return;
        if (!meta && settled) {
          onLocated(pos, null);
          return;
        }
        if (settled) return;
        settled = true;
        onLocated(pos, meta);
      }

      function fail(err) {
        if (settled || myManual !== manualGeoGen) return;
        settled = true;
        onDenied(err, true);
      }

      tryNetworkLocationFallback()
        .then(function (pos) {
          networkFinished = true;
          succeed(pos, NETWORK_LOCATE_META);
        })
        .catch(function () {
          networkFinished = true;
          if (gpsFinished && !settled) fail({ code: 2 });
        });

      try {
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            gpsFinished = true;
            succeed(pos, null);
          },
          function (err) {
            gpsFinished = true;
            if (settled || myManual !== manualGeoGen) return;
            if (err && err.code === 1) {
              fail(err);
              return;
            }
            if (networkFinished && !settled) fail(err || { code: 2 });
          },
          { enableHighAccuracy: false, timeout: 4000, maximumAge: 600000 }
        );
      } catch (e) {
        gpsFinished = true;
        if (networkFinished && !settled) fail({ code: 2 });
      }
    }

    function requestUserGeolocation() {
      if (!window.isSecureContext) {
        showLocateStatus('Location requires a secure (HTTPS) connection.', true);
        return;
      }
      if (!navigator.geolocation) {
        showLocateStatus('Location is not supported in this browser.', true);
        return;
      }
      setLocateBusy(true);
      showLocateStatus('Finding your location…', false);
      autoGeoGen++;
      var myManual = ++manualGeoGen;
      geoAutoChainRunning = false;
      var mobile = MOBILE_MQ.matches;

      if (!mobile) {
        requestDesktopLocateFast(myManual);
        return;
      }

      var maxAttempts = 2;

      function finishDenied(err) {
        if (myManual !== manualGeoGen) return;
        showLocateStatus('GPS unavailable — trying approximate network location…', false);
        tryNetworkLocationFallback()
          .then(function (pos) {
            if (myManual !== manualGeoGen) return;
            onLocated(pos, NETWORK_LOCATE_META);
          })
          .catch(function () {
            if (myManual !== manualGeoGen) return;
            onDenied(err, true);
          });
      }

      function tryWatchFallback() {
        if (myManual !== manualGeoGen) return;
        watchPositionOnce(
          { enableHighAccuracy: false, maximumAge: 0 },
          18000,
          function (pos) {
            if (myManual !== manualGeoGen) return;
            onLocated(pos);
          },
          function (err) {
            finishDenied(err);
          }
        );
      }

      function tryManual(attempt) {
        if (myManual !== manualGeoGen) return;
        var opts = manualLocateOptions(attempt, true);
        if (!opts) {
          tryWatchFallback();
          return;
        }
        try {
          navigator.geolocation.getCurrentPosition(
            function (pos) {
              if (myManual !== manualGeoGen) return;
              onLocated(pos);
            },
            function (err) {
              if (myManual !== manualGeoGen) return;
              var code = err && err.code ? err.code : 0;
              if (code === 1) {
                finishDenied(err);
                return;
              }
              if (attempt < maxAttempts - 1) {
                setTimeout(function () {
                  tryManual(attempt + 1);
                }, 500);
                return;
              }
              if (code === 2 || code === 3) {
                tryWatchFallback();
                return;
              }
              finishDenied(err);
            },
            opts
          );
        } catch (e) {
          if (myManual !== manualGeoGen) return;
          if (attempt < maxAttempts - 1) {
            setTimeout(function () {
              tryManual(attempt + 1);
            }, 500);
          } else {
            tryWatchFallback();
          }
        }
      }
      tryManual(0);
    }

    function updateListMeta(count, hasDistance) {
      var countEl = document.getElementById('ve-list-count');
      if (!countEl) return;
      var label = count === 1 ? '1 location' : count + ' locations';
      if (hasDistance) label += ' · sorted by distance';
      countEl.textContent = label;
    }

    function renderList(ven, ref) {
      if (!listEl) return;

      var enriched = ven.map(function (v) {
        var c = resolveCoords(v, fixAuNzLat);
        var dist = null;
        if (ref && c) dist = milesBetween(ref, c);
        return { venue: v, coords: c, dist: dist };
      });

      if (ref) {
        enriched.sort(function (a, b) {
          var da = a.dist != null ? a.dist : Infinity;
          var db = b.dist != null ? b.dist : Infinity;
          if (da !== db) return da - db;
          return String(a.venue.name || '').localeCompare(String(b.venue.name || ''), undefined, { sensitivity: 'base' });
        });
      } else {
        enriched.sort(function (a, b) {
          return String(a.venue.name || '').localeCompare(String(b.venue.name || ''), undefined, { sensitivity: 'base' });
        });
      }

      var html = '';
      var rendered = 0;
      enriched.forEach(function (row) {
        var v = row.venue;
        var c = row.coords;
        if (!c) return;
        var id = venueIdStr(v);
        if (!id) return;
        var kind = resolveMarkerKind(v);
        var thumbHtml = buildVenueCardThumbHtml(v, kind, markerColors);
        var typeLabel = kind === 'popup' ? 'Pop-up' : 'Store';
        var city = v.city != null ? String(v.city).trim() : '';
        var distTrailing =
          ref && row.dist != null
            ? '<span class="ve-card__distance">' + esc(formatDistanceFromMiles(row.dist)) + '</span>'
            : '';

        html += '<article class="ve-card ve-card--' + esc(kind) + '" data-venue-id="' + esc(id) + '" role="listitem">';
        html += '<button type="button" class="ve-card__header">';
        html += thumbHtml;
        html += '<span class="ve-card__header-main">';
        html += '<span class="ve-card__title-row">';
        html += '<span class="ve-card__title">' + esc(v.name) + '</span>';
        html += '<span class="ve-card__type-badge ve-card__type-badge--' + esc(kind) + '">' + esc(typeLabel) + '</span>';
        html += '</span>';
        if (city) html += '<span class="ve-card__city">' + esc(city) + '</span>';
        html += '</span>';
        html += distTrailing;
        html += '</button></article>';
        rendered++;
      });

      listEl.innerHTML = html;
      updateListMeta(rendered, !!ref);

      listEl.querySelectorAll('.ve-card__header').forEach(function (header) {
        function onHeaderActivate(e) {
          if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
          if (e.type === 'keydown') e.preventDefault();
          e.stopPropagation();
          var card = header.closest('.ve-card');
          if (!card) return;
          var vid = String(card.getAttribute('data-venue-id'));
          if (selectedId === vid) {
            selectedId = null;
            closeVenuePopup();
            applySelectionClass();
            return;
          }
          selectVenue(vid, { fly: true, openPopup: true });
        }
        header.addEventListener('click', onHeaderActivate);
        header.addEventListener('keydown', onHeaderActivate);
      });

      applySelectionClass();
    }

    function applySelectionClass() {
      if (!listEl) return;
      listEl.querySelectorAll('.ve-card').forEach(function (card) {
        var id = String(card.getAttribute('data-venue-id'));
        card.classList.toggle('active', id === String(selectedId));
      });
    }

    var VE_MOBILE_LIST_BTN_OPEN =
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg> List';
    var VE_MOBILE_LIST_BTN_CLOSE =
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg> Close';

    function setMobileListPanelOpen(open) {
      var panel = root.querySelector('.ve-list-panel');
      var btn = document.getElementById('ve-search-list-btn');
      if (!panel) return;
      if (open) {
        panel.classList.add('ve--mobile-open');
        if (btn) btn.innerHTML = VE_MOBILE_LIST_BTN_CLOSE;
      } else {
        panel.classList.remove('ve--mobile-open');
        if (btn) btn.innerHTML = VE_MOBILE_LIST_BTN_OPEN;
      }
    }

    function closeMobileListPanel() {
      if (!MOBILE_MQ.matches) return;
      var panel = root.querySelector('.ve-list-panel');
      if (!panel || !panel.classList.contains('ve--mobile-open')) return;
      setMobileListPanelOpen(false);
    }

    function selectVenue(id, opts) {
      var sid = id != null ? String(id) : '';
      var wasAlreadySelected = sid !== '' && selectedId != null && String(selectedId) === sid;
      selectedId = sid;
      applySelectionClass();
      var entry = markerMap.get(sid);
      if (!entry || !map) {
        var cardOnly = null;
        if (listEl) {
          var nodes = listEl.querySelectorAll('.ve-card');
          for (var j = 0; j < nodes.length; j++) {
            if (String(nodes[j].getAttribute('data-venue-id')) === sid) {
              cardOnly = nodes[j];
              break;
            }
          }
        }
        if (cardOnly && cardOnly.scrollIntoView) {
          cardOnly.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        return;
      }
      var fly = opts && opts.fly;
      var openPopup = opts && opts.openPopup;
      if (wasAlreadySelected) {
        openPopup = true;
        fly = false;
      }
      if (fly) {
        var ll = entry.marker.getLngLat();
        mapEaseToVenueTwoStage(ll.lat, ll.lng);
      }
      if (openPopup) {
        if (popupAfterFlyTimer) {
          clearTimeout(popupAfterFlyTimer);
          popupAfterFlyTimer = null;
        }
        if (fly) {
          popupAfterFlyTimer = setTimeout(function () {
            popupAfterFlyTimer = null;
            openVenuePopupAt(entry.venue, entry.coords);
          }, 3920);
        } else {
          openVenuePopupAt(entry.venue, entry.coords);
        }
      } else {
        closeVenuePopup();
      }
      var card = null;
      if (listEl) {
        var nodes2 = listEl.querySelectorAll('.ve-card');
        for (var i = 0; i < nodes2.length; i++) {
          if (String(nodes2[i].getAttribute('data-venue-id')) === sid) {
            card = nodes2[i];
            break;
          }
        }
      }
      if (card && card.scrollIntoView) {
        card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      if (MOBILE_MQ.matches && sid && !wasAlreadySelected) {
        closeMobileListPanel();
      }
    }

    function onDataReady() {
      if (explorerInited) return;
      explorerInited = true;
      venueWorkshopEvents = parseVenueWorkshopEvents();
      parseWorkshopProductHandles();

      function startMapAndGeo() {
        if (typeof maplibregl !== 'undefined') {
          initMap();
        } else {
          var tries = 0;
          var t = setInterval(function () {
            tries++;
            if (typeof maplibregl !== 'undefined') {
              clearInterval(t);
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  initMap();
                });
              });
            } else if (tries > 80) clearInterval(t);
          }, 50);
        }

        bindGeolocationReliabilityHooks();
        bindMobileFirstInteractionGeolocation();

        if (!navigator.geolocation) {
          onDenied(null, false);
        } else if (MOBILE_MQ.matches) {
          scheduleAutomaticGeolocation(400);
        }
      }

      function applyWorkshopEventsAndStart(rows) {
        venueWorkshopEvents = Array.isArray(rows) ? rows : [];
        indexVenueWorkshopEvents(venueWorkshopEvents);
        renderList(getDisplayVenues(), null);
        setupVenueInventorySearch();
        requestAnimationFrame(function () {
          requestAnimationFrame(startMapAndGeo);
        });
      }

      var seedRows = venueWorkshopEvents;
      /* Wait for API enrich so the list does not jump from seed (~9) to full (~31). */
      enrichVenueWorkshopEventsFromApi(seedRows)
        .then(function (merged) {
          applyWorkshopEventsAndStart(Array.isArray(merged) ? merged : seedRows);
        })
        .catch(function () {
          applyWorkshopEventsAndStart(seedRows);
        });
    }

    function enrichVenueWorkshopEventsFromApi(seedRows) {
      var proxyBase = String(root.getAttribute('data-events-proxy') || '/apps/workshop-events')
        .trim()
        .replace(/\/+$/, '');
      var eventsPath = String(root.getAttribute('data-events-path') || '/events-v').trim();
      if (eventsPath.charAt(0) !== '/') eventsPath = '/' + eventsPath;
      var lat = Number(root.getAttribute('data-events-lat'));
      var lng = Number(root.getAttribute('data-events-lng'));
      var radiusKm = Number(root.getAttribute('data-events-radius-km'));
      if (!Number.isFinite(lat)) lat = 39.833333;
      if (!Number.isFinite(lng)) lng = -98.583333;
      if (!Number.isFinite(radiusKm) || radiusKm <= 0) radiusKm = 5000;

      /**
       * events-v ~20 venues/query. National call + include_empty=false covers most.
       * One SE mosaic supplement recovers East venues (e.g. Knoxville) outside that cap.
       * Keep request count low: 3 products × national + 1 SE mosaic = 4 (not 15).
       */
      function fetchEventsAt(gid, handle, centerLat, centerLng, centerRadius) {
        var shared = typeof window !== 'undefined' ? window.AMCWorkshopEventsV : null;
        var req = {
          productGid: gid,
          lat: centerLat,
          lng: centerLng,
          radiusKm: centerRadius,
          includeEmpty: false,
          proxyBase: proxyBase,
          eventsPath: eventsPath
        };
        var load =
          shared && typeof shared.get === 'function'
            ? shared.get(req)
            : fetch(
                proxyBase +
                  eventsPath +
                  '?product_gid=' +
                  encodeURIComponent(gid) +
                  '&lat=' +
                  encodeURIComponent(centerLat) +
                  '&lng=' +
                  encodeURIComponent(centerLng) +
                  '&radius_km=' +
                  encodeURIComponent(centerRadius) +
                  '&include_empty_venues=false',
                { credentials: 'same-origin' }
              ).then(function (res) {
                if (!res.ok) return null;
                return res.json();
              });
        return load
          .then(function (data) {
            return flattenWorkshopEventsFromApiPayload(data, handle);
          })
          .catch(function () {
            return [];
          });
      }

      var jobs = [];
      VE_WORKSHOP_TYPE_ORDER.forEach(function (type) {
        var id = veWorkshopProductIds[type];
        var handle = veWorkshopProductHandles[type] || (VE_WORKSHOP_TYPES[type] && VE_WORKSHOP_TYPES[type].handle) || '';
        if (!id) return;
        var gid = String(id).indexOf('gid://') === 0 ? String(id) : 'gid://shopify/Product/' + String(id);
        jobs.push(fetchEventsAt(gid, handle, lat, lng, radiusKm));
        if (type === 'mosaic') {
          jobs.push(fetchEventsAt(gid, handle, 35.96, -83.92, 1200));
        }
      });

      if (!jobs.length) return Promise.resolve(seedRows || []);

      return Promise.all(jobs).then(function (chunks) {
        var apiRows = [];
        chunks.forEach(function (chunk) {
          if (Array.isArray(chunk) && chunk.length) apiRows = apiRows.concat(chunk);
        });
        return mergeWorkshopEventLists(seedRows, apiRows);
      });
    }

    function loadVenuesData() {
      var inline = parseInlineVenueData();
      if (!venuesUrl) return Promise.resolve(inline);
      return fetch(venuesUrl)
        .then(function (r) {
          return r.ok ? r.json() : [];
        })
        .then(function (rows) {
          var fromJson = normalizeVenues(rows);
          if (!inline.length) return fromJson;
          if (!fromJson.length) return inline;
          return mergeVenueCatalog(fromJson, inline);
        })
        .catch(function () {
          console.warn('[venue-explorer] venues_data.json could not be loaded; trying inline fallback.');
          return inline.length ? inline : parseInlineVenueData();
        });
    }

    loadVenuesData().then(function (rows) {
      venues = filterAmericasVenues(rows || [], fixAuNzLat);
      venues = filterAllowedStateVenues(venues, allowedStates);
      try {
        window.__venueExplorerVenues = venues.slice();
        window.dispatchEvent(
          new CustomEvent('venue-explorer:data-ready', {
            detail: { venues: window.__venueExplorerVenues }
          })
        );
      } catch (e) {
        /* ignore */
      }
      onDataReady();
    });

    function parseVenueWorkshopEvents() {
      var el = document.getElementById('venue-explorer-events');
      if (!el || !el.textContent) return [];
      try {
        var rows = JSON.parse(el.textContent);
        return Array.isArray(rows) ? rows : [];
      } catch (e) {
        console.warn('[venue-explorer] Workshop events JSON could not be parsed.');
        return [];
      }
    }

    function syncDistanceUnitButtons() {
      var u = getDistanceUnit();
      var btn = document.getElementById('ve-distance-unit-toggle');
      if (!btn) return;
      var label = btn.querySelector('.ve-distance-unit-btn__label');
      if (label) label.textContent = u === 'mi' ? 'Mi' : 'Km';
      else btn.textContent = u === 'mi' ? 'Mi' : 'Km';
      btn.classList.toggle('ve-distance-unit-btn--km', u === 'km');
      btn.setAttribute(
        'aria-label',
        u === 'mi'
          ? 'Distances in miles. Tap to switch to kilometers.'
          : 'Distances in kilometers. Tap to switch to miles.'
      );
    }

    function onDistanceUnitChange(unit) {
      setDistanceUnit(unit);
      syncDistanceUnitButtons();
      renderList(getDisplayVenues(), getListDistanceRef());
    }

    var unitToggleBtn = document.getElementById('ve-distance-unit-toggle');
    if (unitToggleBtn) {
      unitToggleBtn.addEventListener('click', function () {
        var next = getDistanceUnit() === 'mi' ? 'km' : 'mi';
        onDistanceUnitChange(next);
      });
    }
    syncDistanceUnitButtons();

    function onLocateButtonClick(e) {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      requestUserGeolocation();
    }

    if (locateBtn) {
      locateBtn.addEventListener('click', onLocateButtonClick);
    }

    var locateFab = document.getElementById('ve-locate-fab');
    if (locateFab) {
      locateFab.addEventListener('click', onLocateButtonClick);
    }

    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        onSearchButtonClick();
      });
    }

    function applyMobilePanels(view) {
      if (!listEl || !mapEl) return;
      var isMobile = MOBILE_MQ.matches;
      if (!isMobile) {
        if (listShell) listShell.classList.remove('ve-panel--hidden');
        else listEl.classList.remove('ve-panel--hidden');
        listEl.classList.remove('ve-panel--hidden');
        mapEl.classList.remove('ve-panel--hidden');
        if (map) {
          setTimeout(scheduleMapResize, 50);
          setTimeout(scheduleMapResize, 200);
        }
        return;
      }
      /* Mobil: tam ekran harita + Liste düğmesiyle açılan panel */
      if (listShell) listShell.classList.remove('ve-panel--hidden');
      else listEl.classList.remove('ve-panel--hidden');
      listEl.classList.remove('ve-panel--hidden');
      mapEl.classList.remove('ve-panel--hidden');
      if (map) scheduleMapResize();
    }

    var toggleBtns = root.querySelectorAll('.ve-mobile-toggle__btn');
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-ve-view');
        toggleBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('ve-mobile-toggle__btn--active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        applyMobilePanels(view);
      });
    });

    function syncMobileDefault() {
      applyMobilePanels('list');
      if (bodyRow) {
        if (MOBILE_MQ.matches) {
          bodyRow.classList.remove('ve--sidebar-collapsed');
          updateSidebarToggleA11y(false);
        } else {
          bodyRow.classList.add('ve--sidebar-collapsed');
          updateSidebarToggleA11y(false);
        }
      }
      if (map) scheduleMapResize();
    }

    if (bodyRow && listShell) {
      var panelTabBtn = document.getElementById('ve-list-sidebar-toggle');
      if (panelTabBtn) {
        panelTabBtn.addEventListener('click', function () {
          if (MOBILE_MQ.matches) return;
          var collapsed = bodyRow.classList.contains('ve--sidebar-collapsed');
          if (collapsed) {
            bodyRow.classList.remove('ve--sidebar-collapsed');
            updateSidebarToggleA11y(true);
          } else {
            bodyRow.classList.add('ve--sidebar-collapsed');
            updateSidebarToggleA11y(false);
          }
        });
      }
    }

    function toggleMobilePanel() {
      var panel = root.querySelector('.ve-list-panel');
      if (!panel) return;
      setMobileListPanelOpen(!panel.classList.contains('ve--mobile-open'));
    }

    var mobilePullTab = document.getElementById('ve-mobile-pull-tab');
    if (mobilePullTab) mobilePullTab.addEventListener('click', toggleMobilePanel);

    var searchListBtn = document.getElementById('ve-search-list-btn');
    if (searchListBtn) searchListBtn.addEventListener('click', toggleMobilePanel);

    var zoomInBtn = document.getElementById('ve-zoom-in');
    var zoomOutBtn = document.getElementById('ve-zoom-out');
    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function () {
        if (map && typeof map.zoomIn === 'function') {
          map.zoomIn({ duration: 300 });
        }
      });
    }
    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function () {
        if (map && typeof map.zoomOut === 'function') {
          map.zoomOut({ duration: 300 });
        }
      });
    }

    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', function () {
        toggleFullscreenView();
      });
      document.addEventListener('fullscreenchange', syncFullscreenUi);
      document.addEventListener('webkitfullscreenchange', syncFullscreenUi);
      document.addEventListener('mozfullscreenchange', syncFullscreenUi);
      document.addEventListener('MSFullscreenChange', syncFullscreenUi);
      syncFullscreenUi();
    }

    root.querySelectorAll('.ve-legend-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.querySelector('.ve-legend-btn__label');
        if (!label) {
          label = document.createElement('span');
          label.className = 've-legend-btn__label';
          label.textContent = btn.getAttribute('data-label') || '';
          btn.appendChild(label);
        }
        btn.classList.toggle('ve--label-visible');
        setTimeout(function () {
          btn.classList.remove('ve--label-visible');
        }, 2000);
      });
    });

    syncMobileDefault();
    MOBILE_MQ.addEventListener('change', syncMobileDefault);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }
})();
